/**
 * Afters game runtime — Babylon scene, session, boot.
 * Leaf systems live under ./audio ./avatar ./ui ./world ./input and ../platform.
 * Recovered from Wavedash production build #182.
 */
import {
  A as e, B as t, C as n, D as r, E as i, F as a, H as o, I as s,
  L as c, M as l, N as u, O as d, P as f, R as p, S as m, T as h, V as g,
  _, a as v, b as y, c as b, d as ee, f as te, g as x, h as ne, i as re,
  j as ie, k as S, l as ae, m as oe, n as se, o as C, p as ce, r as le,
  s as ue, t as de, u as fe, v as pe, w as me, x as w, y as he, z as T,
} from "../vendor/babylon.js";


import { E, D, ve, O, k, ye, be, A } from "./math.js";
import { ge, _e } from "./audio/paths.js";
import { xe, j, Se, Ce, we, Te } from "./audio/beats.js";
import { Oe, De, Ee, M, ke, Ae, je, Me, Ne, Pe } from "./audio/engine.js";
import { Fe } from "./audio/sfx.js";
import { mt } from "./audio/ambience.js";
import {
  Ie, Le, N, Re, P, ze, Be, Ve, He, F, Ue, We, Ge, Ke, qe, Je, Ye, Xe, Ze, Qe,
  $e, et, I, L, tt, nt, R, z, rt, it, at, ot, st, ct, lt, ut, dt, ft, pt,
} from "./avatar/pose.js";
import { ht, gt, _t, B } from "../platform/sdk.js";
import { vt, yt } from "./ui/icons.js";
import { V, bt, xt, St, Ct, wt } from "./ui/dom.js";
import { Tt, Et, Dt } from "./ui/hud.js";
import { Ot, kt, characterSelect } from "./ui/menus.js";
import {
  At, jt, H, U, W, G, K, Mt, Nt, Pt, Ft, q, It, Lt, Rt, zt, Bt, Vt, Ht,
  J, Ut, Y, Wt, Gt, Kt, qt, Jt, Yt, Xt,
} from "./world/zones.js";
import { kn, An, jn, Mn, Nn, Pn, Fn, In, Rn, Ln, zn } from "./input/controls.js";
import { QUALITY as Un, isTouchDevice as Wn, pickQuality as Gn } from "./quality.js";
import {
  loadRoster,
  getSavedCharacter,
  saveCharacter,
  displayName,
} from "./characters/roster.js";

const X = (e, t, n) => new g(e, t, n),
    Zt = X(0, 0, 0),
    Qt = X(.62, .72, 1),
    $t = X(.34, .42, .66),
    en = X(.08, .09, .12),
    tn = X(1, .93, .78),
    nn = X(1, .05, .05),
    rn = X(.58, .68, .9),
    an = X(.72, .82, .95),
    on = X(.55, .65, .82),
    sn = X(.78, .88, 1),
    cn = X(.36, .42, .55),
    ln = X(1, .7, .4),
    un = [X(.3, .75, 1), X(.85, .25, .7), X(.5, .38, 1)],
    dn = X(.5, .55, .62),
    fn = X(.3, .34, .39),
    pn = X(.44, .49, .55),
    mn = {
        amount: 1,
        fogColor: new g(.4, .45, .5),
        density: .1
    },
    hn = class extends f {
        constructor(e) {
            super(e, `AftersReveal`, 210, {
                AFTERS_REVEAL: !1
            }, !0, !0)
        }
        getClassName() {
            return `AftersRevealPlugin`
        }
        prepareDefines(e) {
            e.AFTERS_REVEAL = !0
        }
        getUniforms() {
            return {
                ubo: [{
                    name: `revealPresence`,
                    size: 1,
                    type: `float`
                }, {
                    name: `revealHaze`,
                    size: 1,
                    type: `float`
                }, {
                    name: `revealBlend`,
                    size: 1,
                    type: `float`
                }, {
                    name: `revealDensity`,
                    size: 1,
                    type: `float`
                }, {
                    name: `revealFogColor`,
                    size: 3,
                    type: `vec3`
                }],
                fragment: `#ifdef AFTERS_REVEAL
uniform float revealPresence;
uniform float revealHaze;
uniform float revealBlend;
uniform float revealDensity;
uniform vec3 revealFogColor;
#endif`
            }
        }
        bindForSubMesh(e) {
            let t = mn.amount;
            e.updateFloat(`revealPresence`, k(0, .3, t)), e.updateFloat(`revealHaze`, ve(.095, .042, t)), e.updateFloat(`revealBlend`, k(.72, 1, t)), e.updateFloat(`revealDensity`, mn.density), e.updateColor3(`revealFogColor`, mn.fogColor)
        }
        getCustomCode(e) {
            return e === `fragment` ? {
                CUSTOM_FRAGMENT_BEFORE_FOG: `
#ifdef AFTERS_REVEAL
{
  float revealD = length(vPositionW - vEyePosition.xyz);
  float revealVis = mix(revealPresence * exp(-revealHaze * revealD), exp(-pow(revealDensity * revealD, 2.0)), revealBlend);
  color.rgb = mix(revealFogColor, color.rgb, clamp(revealVis, 0.0, 1.0));
}
#endif`
            } : null
        }
    };

function gn(e) {
    e.pluginManager?.getPlugin(`AftersReveal`) || (e.fogEnabled = !1, new hn(e))
}
var _n = {
    time: 0,
    strength: 1,
    target: 1
};

function vn(e) {
    _n.time += e, _n.strength = A(_n.strength, _n.target, .8, e)
}
var yn = class extends f {
    amp;
    height;
    constructor(e, t, n) {
        super(e, `AftersSway`, 200, {
            AFTERS_SWAY: !1
        }, !0, !0), this.amp = t, this.height = n
    }
    getClassName() {
        return `AftersSwayPlugin`
    }
    prepareDefines(e) {
        e.AFTERS_SWAY = !0
    }
    getUniforms() {
        return {
            ubo: [{
                name: `swayTime`,
                size: 1,
                type: `float`
            }, {
                name: `swayAmp`,
                size: 1,
                type: `float`
            }, {
                name: `swayHeight`,
                size: 1,
                type: `float`
            }],
            vertex: `#ifdef AFTERS_SWAY
uniform float swayTime;
uniform float swayAmp;
uniform float swayHeight;
#endif`
        }
    }
    bindForSubMesh(e) {
        e.updateFloat(`swayTime`, _n.time), e.updateFloat(`swayAmp`, this.amp * _n.strength), e.updateFloat(`swayHeight`, this.height)
    }
    getCustomCode(e) {
        return e === `vertex` ? {
            CUSTOM_VERTEX_UPDATE_WORLDPOS: `
#ifdef AFTERS_SWAY
{
  vec3 swayBase = finalWorld[3].xyz;
  float swayH = max(0.0, worldPos.y - swayBase.y) / swayHeight;
  float swayK = swayAmp * swayH * swayH;
  float swayPh = swayBase.x * 0.21 + swayBase.z * 0.17;
  float swayT = swayTime - swayBase.z * 0.03;
  worldPos.x += swayK * (sin(swayT * 0.8 + swayPh) + 0.35 * sin(swayT * 2.1 + swayPh * 1.7));
  worldPos.z += swayK * 0.6 * cos(swayT * 0.63 + swayPh * 1.3);
}
#endif`
        } : null
    }
};

function bn(e, t, n) {
    new yn(e, t, n)
}
var xn = {
        danceLeft: `left`,
        danceUp: `up`,
        danceRight: `right`,
        danceDown: `down`
    },
    Sn = -125,
    Cn = .046,
    wn = .12,
    Tn = 8,
    En = {
        forest: `Walking through the woods`,
        pipe: `Down in the drain`,
        club: `On the dance floor`
    },
    Dn = class {
        world;
        audio;
        sfx;
        input;
        ui;
        paused = !1;
        touch = null;
        hud;
        ambience;
        djBase = Be();
        forward = new T;
        eye = new T;
        awaitingGesture = !0;
        moved = !1;
        zoneNow = null;
        sawClub = !1;
        muted = !1;
        beat = 0;
        jumpQueued = !1;
        snapshotWanted = !1;
        hadPointerLock = !1;
        lookedAt = 0;
        gustUntil = 0;
        gustStrength = 0;
        dropBar = null;
        djLift = 0;
        fog = {
            color: new g(.035, .045, .075),
            density: .02
        };
        exposure = 1.3;
        characterName = null;
        charPreview = null;
        constructor(e, t, n, r, i) {
            this.world = e, this.audio = t, this.sfx = n, this.input = r, this.ui = i, this.characterName = e.player.characterName || getSavedCharacter(), this.hud = new Dt(() => this.pause()), i.root.prepend(this.hud.el), r.on(e => this.onAction(e)), e.stage.canvas.addEventListener(`click`, () => !this.paused && this.input.lockPointer()), document.addEventListener(`pointerlockchange`, () => this.onPointerLock()), e.atmosphere.onDrip = (e, t) => n.drip(e, t), this.ambience = new mt(n, (e, t) => {
                this.gustUntil = performance.now() / 1e3 + t * .6, this.gustStrength = e
            })
        }
        start() {
            let e = this.world.player;
            e.teleport(At.x, At.z, At.yaw), this.world.camera.snapBehind(e.pos, At.yaw), this.hud.controls(this.input.device, !1), this.audio.unlock(), this.hud.startPrompt(this.touch ? `Tap to begin` : this.input.device === `gamepad` ? `Click once to turn the sound on` : `Click to begin`)
        }
        get zone() {
            return Rt(this.world.player.pos.z)
        }
        debugTeleport(e, t) {
            this.world.player.teleport(e, t, 0), this.world.camera.snapBehind(this.world.player.pos, 0)
        }
        debugDrop() {
            this.startDrop(-1), setTimeout(() => this.endDrop(), 8e3)
        }
        pause() {
            this.paused || (this.paused = !0, this.input.unlockPointer(), this.hud.setMenuHidden(!0), this.touch?.setHidden(!0), this.openSettings())
        }
        openSettings() {
            this.ui.clear(), this.ui.push(Ot({
                onResume: () => this.resume(),
                onChangeCharacter: () => this.openCharacterSelect()
            }))
        }
        resume() {
            this.ui.clear(), this.paused = !1, this.hud.setMenuHidden(!1), this.touch?.setHidden(!1), this.input.lockPointer()
        }
        async openCharacterSelect() {
            let e = await loadRoster(),
                t = this.characterName || this.world.player.characterName;
            this.ui.push(characterSelect({
                roster: e,
                currentName: t,
                mountPreview: canvas => {
                    try {
                        this.charPreview?.dispose?.()
                    } catch {}
                    const preview = createCharacterPreview(canvas, this.world.stage),
                        dispose = preview.dispose.bind(preview);
                    preview.dispose = () => {
                        dispose();
                        if (this.charPreview === preview) this.charPreview = null
                    };
                    this.charPreview = preview;
                    return preview
                },
                onBack: () => this.ui.pop(),
                onPick: async entry => {
                    this.ui.toast(`Loading ${displayName(entry.name)}…`, 900);
                    await this.world.swapPlayer(entry.name);
                    this.characterName = entry.name;
                    saveCharacter(entry.name);
                    try {
                        this.sfx.done()
                    } catch {}
                    this.ui.toast(displayName(entry.name), 1400);
                    this.ui.pop()
                }
            }))
        }
        onPointerLock() {
            let e = this.input.pointerLocked,
                t = !e && this.input.consumeIntentionalUnlock();
            !e && !t && this.hadPointerLock && !this.paused && this.pause(), this.hadPointerLock = e
        }
        onAction(e) {
            if (e.action === `fullscreen`) return void B.toggleFullscreen();
            if (e.action === `mute`) return void this.toggleMute();
            if (this.ui.handle(e)) return;
            if (e.action === `pause`) return this.paused ? this.resume() : this.pause();
            e.action === `photo` && (this.snapshotWanted = !0), e.action === `jump` && (this.jumpQueued = !0), e.action === `view` && this.world.camera.toggleView();
            let t = xn[e.action];
            t && this.zone === `club` && this.world.player.speed < .5 && this.world.player.dance(t, this.beat), e.action === `jump` && e.device === `keyboard` && this.input.lockPointer()
        }
        async toggleMute() {
            await B.toggleMute() || (this.muted = !this.muted, this.audio.setMuted(this.muted), this.ui.toast(this.muted ? `Muted` : `Sound on`, 1200))
        }
        update(e) {
            let t = this.world,
                n = t.player;
            this.input.poll(), this.audio.tickClock(), this.beat = this.audio.beat();
            let r = this.beat,
                i = this.input.look(e);
            if (this.paused || t.camera.turn(i.dx, i.dy), (i.dx || i.dy) && (this.lookedAt = performance.now()), !this.paused) {
                let i = this.input.move(),
                    a = this.jumpQueued;
                this.jumpQueued = !1, !this.moved && (Math.abs(i.x) + Math.abs(i.z) > .1 || a) && (this.moved = !0, this.hud.hideControls());
                let o = this.zone,
                    s = o === `forest` ? t.forest.near(n.pos.x, n.pos.z) : [],
                    c = o === `club` ? t.crowd.density(n.pos.x, n.pos.z) : 0,
                    l = o === `club` ? t.crowd.groove(n.pos.x, n.pos.z, t.camera.yaw) ?? at : null;
                n.update(e, {
                    ...i,
                    jump: a,
                    faceCamera: t.camera.firstPerson
                }, t.camera.yaw, s, c, r, l)
            }
            this.updatePlace(), this.updateDrops();
            let a = qt(n.pos.x, n.pos.z, n.pos.y),
                o = n.pos.y - a;
            t.blob.position.set(n.pos.x, a + .03, n.pos.z), t.blob.scaling.setAll(Math.max(.5, 1 - o * .35)), t.blob.visibility = Math.max(.3, 1 - o * .5);
            let s = t.camera.position,
                c = Rt(s.z),
                l = this.audio.bass(),
                u = un[ye(Math.floor(r / 16), un.length)],
                d = zt(n.pos.z),
                f = this.dropBar !== null;
            t.showZones(d), mn.amount = k(U.zEnd - 36, U.zEnd + 2, s.z), d.club && this.updateDj(e, r), t.club.update(e, {
                beat: r,
                bass: l,
                reveal: mn.amount
            }), t.club.setLightsOn(d.club), t.lights.update(e, {
                beat: r,
                bass: l,
                level: f ? 1 : .25,
                visible: d.club,
                camera: s,
                tint: u,
                reveal: mn.amount
            }), t.crowd.update(r, this.zone === `club` ? n.pos : null, e), t.forest.update(n.pos, l, d.forest), t.pipe.update(e, n.pos, l, d.pipe), t.sky.setVisible(d.forest && (c === `forest` || s.z < U.zStart + 24)), t.sky.update(e), t.particles.update(e, {
                player: n.pos,
                zone: c,
                live: d,
                beat: r,
                bass: l,
                drop: f
            }), this.updateFog(e, s.z, l, r, u), _n.target = performance.now() / 1e3 < this.gustUntil ? 1 + this.gustStrength * 1.8 : 1, vn(e), t.atmosphere.update(e, {
                player: n.pos,
                camera: s,
                live: d,
                fogColor: this.fog.color,
                fogDensity: this.fog.density,
                reveal: mn.amount
            }), this.paused || this.ambience.update(e, s, c), this.awaitingGesture && this.audio.started && (this.awaitingGesture = !1, this.hud.startPrompt(null)), this.hud.followDevice(this.input.device), this.hud.setMapPlayer(n.pos.x, n.pos.z, n.facing), this.touch?.setHidden(this.paused), this.input.device !== `keyboard` && !t.camera.firstPerson && !this.paused && performance.now() - this.lookedAt > 1400 && t.camera.follow(e, n.facing, n.speed), t.camera.update(e, {
                player: n.pos,
                eye: n.eye(this.eye),
                speed: n.speed,
                aspect: t.stage.engine.getAspectRatio(t.stage.camera)
            }), n.avatar.mesh.isVisible = !t.camera.inHead, this.audio.update(s, t.camera.forward(this.forward), On(s.z), e), t.stage.tickPost()
        }
        afterRender() {
            this.snapshotWanted && (this.snapshotWanted = !1, this.takeSnapshot())
        }
        updatePlace() {
            let e = this.zone;
            e !== this.zoneNow && (this.zoneNow = e, B.presence(En[e]), this.touch?.setClubMode?.(e === `club`), e === `club` && !this.sawClub && (this.sawClub = !0, this.hud.controls(this.input.device, !0)))
        }
        updateDrops() {
            if (!this.audio.started || this.dropBar === -1) return;
            let e = Math.floor(ye(this.beat, j.length) / 4);
            this.dropBar === null && Se.includes(e) ? this.startDrop(e) : this.dropBar !== null && (e >= this.dropBar + Tn || e < this.dropBar) && this.endDrop()
        }
        startDrop(e) {
            this.dropBar === null && (this.dropBar = e, this.djLift = 1, this.world.crowd.setHype(!0), this.world.particles.drop(), this.zone === `club` && (this.sfx.cheer(.9), this.input.rumble(.55, .35, 380)))
        }
        endDrop() {
            this.dropBar = null, this.world.crowd.setHype(!1)
        }
        updateDj(e, t) {
            let n = this.world.dj;
            this.djLift = Math.max(this.dropBar === null ? 0 : .6 + .4 * Math.max(0, Math.sin(t * Math.PI)), this.djLift - e * 1.5), ft(ye(t, 4), this.djLift, this.djBase), Ve(this.djBase, n.pose), n.mesh.position.set(Mt.x, Mt.y, Mt.z), n.mesh.rotation.y = Mt.yaw, n.commit()
        }
        updateFog(e, t, n, r, i) {
            let a = this.world.stage.scene,
                o = D((t - Sn) / (W.zMin + 2 - Sn)),
                s = t > W.zMin,
                c = s ? .05 + n * .06 + Te(r) * .03 : 0,
                l = k(U.zEnd - 30, U.zEnd - 10, t) * (1 - k(U.zEnd - 2, U.zEnd + 10, t)),
                u = ve(Cn, wn, o ** 1.15) + l * .035 + (this.dropBar !== null && s ? .018 : 0),
                d = g.Lerp(fn, pn, o).addInPlaceFromFloats((i.r - .5) * c, (i.g - .5) * c, (i.b - .5) * c),
                f = Math.min(1, e * 3),
                p = this.fog;
            p.color = g.Lerp(p.color, d, f), p.density = ve(p.density, u, f), a.fogColor.copyFrom(p.color), a.fogDensity = p.density, a.clearColor.set(p.color.r, p.color.g, p.color.b, 1), mn.fogColor.copyFrom(p.color), mn.density = p.density, this.world.sky.setHaze(p.color, Math.min(1, .55 + o)), this.exposure = ve(this.exposure, 1.3 - o * .28, f), this.world.stage.setExposure(this.exposure)
        }
        takeSnapshot() {
            let e = this.world.stage.canvas,
                t = document.createElement(`canvas`),
                n = Math.max(1, Math.ceil(1280 / e.width));
            t.width = e.width * n, t.height = e.height * n;
            let r = t.getContext(`2d`);
            r.imageSmoothingEnabled = !1, r.drawImage(e, 0, 0, t.width, t.height);
            let i = getComputedStyle(document.documentElement).getPropertyValue(`--font`),
                a = t.height * .035,
                o = Math.max(14, t.height * .035),
                s = B.playerName();
            r.textBaseline = `bottom`, r.shadowColor = `rgba(0,0,0,0.6)`, r.shadowBlur = o * .6, r.font = `700 ${o}px ${i}`, r.fillStyle = `rgba(255,255,255,0.9)`, r.fillText(`AFTERS`, a, t.height - a), r.shadowBlur = 0, r.font = `400 ${o*.5}px ${i}`, r.fillStyle = `rgba(255,255,255,0.7)`, r.fillText(`${s} at the afters`, a, t.height - a - o * 1.15);
            let c = t.toDataURL(`image/png`),
                l = Uint8Array.from(atob(c.split(`,`)[1]), e => e.charCodeAt(0));
            this.sfx.shutter();
            let u = V(`div`, {
                class: `flash`
            });
            u.addEventListener(`animationend`, () => u.remove()), document.body.append(u);
            let d = this.paused;
            this.paused = !0, this.input.unlockPointer(), this.ui.push(kt({
                dataUrl: c,
                png: l,
                online: B.online,
                share: async e => {
                    let t = await B.shareScreenshot(e, `${s} at the afters`, `A night out in AFTERS`);
                    return t && this.sfx.done(), t
                },
                close: () => {
                    this.ui.pop(), !d && (this.paused = !1, this.input.lockPointer())
                }
            }))
        }
    };

function On(e) {
    let t = e => ({
        muffle: .64 - .48 * e ** 1.3,
        level: .58 + .34 * e,
        wide: .1 * e,
        forest: (1 - e) ** 3 * .5,
        pipe: 1,
        club: e * e * .5,
        pipeVerb: .9 - .45 * e,
        hallVerb: .25 * e
    });
    if (e < U.zStart) {
        let n = U.zStart - e,
            r = D(1 - n / 70),
            i = {
                muffle: .93 - .26 * r,
                level: .3 + .3 * r,
                wide: 0,
                forest: 1,
                pipe: D(1 - n / 10) * .6,
                club: 0,
                pipeVerb: .25 * r,
                hallVerb: 0
            },
            a = D(1 - n / 8),
            o = t(0);
        for (let e of Object.keys(i)) i[e] = ve(i[e], o[e], a);
        return i
    }
    if (e < U.zEnd) return t(D((e - U.zStart) / (U.zEnd - U.zStart)));
    let n = D((e - U.zEnd) / 7);
    return {
        muffle: .16 * (1 - n),
        level: .92 + .08 * n,
        wide: .1 + .85 * n,
        forest: 0,
        pipe: 1 - n,
        club: .5 + .5 * n,
        pipeVerb: .45 * (1 - n),
        hallVerb: .25 + .25 * n
    }
}

const Bn = class extends f {
        constructor(e) {
            super(e, `AftersPsxSnap`, 220, {
                AFTERS_PSX_SNAP: !1
            }, !0, !0)
        }
        getClassName() {
            return `AftersPsxSnapPlugin`
        }
        prepareDefines(e) {
            e.AFTERS_PSX_SNAP = !0
        }
        getUniforms() {
            return {
                ubo: [{
                    name: `psxGrid`,
                    size: 2,
                    type: `vec2`
                }],
                vertex: `#ifdef AFTERS_PSX_SNAP
uniform vec2 psxGrid;
#endif`
            }
        }
        bindForSubMesh(e) {
            e.updateFloat2(`psxGrid`, zn.width, zn.height)
        }
        getCustomCode(e) {
            return e === `vertex` ? {
                CUSTOM_VERTEX_MAIN_END: `
#ifdef AFTERS_PSX_SNAP
{
  vec2 psxHalf = psxGrid * 0.5;
  gl_Position.xy = floor(gl_Position.xy / gl_Position.w * psxHalf + 0.5) / psxHalf * gl_Position.w;
}
#endif`
            } : null
        }
    };

function Vn(e, t) {
    for (let t of e.materials) t instanceof h && !t.pluginManager?.getPlugin(`AftersPsxSnap`) && new Bn(t);
    for (let n of e.textures) n instanceof d || n instanceof me || !(n instanceof S) || t.has(n.name) || n.samplingMode !== S.NEAREST_NEAREST_MIPNEAREST && n.updateSamplingMode(S.NEAREST_NEAREST_MIPNEAREST)
}
s.ShadersStore.aftersPsxFragmentShader = `
precision highp float;
varying vec2 vUV;
uniform sampler2D textureSampler;
float bayer2(vec2 a) { a = floor(a); return fract(a.x / 2.0 + a.y * a.y * 0.75); }
float bayer4(vec2 a) { return bayer2(0.5 * a) * 0.25 + bayer2(a); }
void main() {
  vec3 c = texture2D(textureSampler, vUV).rgb;
  float d = bayer4(gl_FragCoord.xy) - 0.5;
  c = floor(clamp(c, 0.0, 1.0) * 31.0 + 0.5 + d) / 31.0;
  gl_FragColor = vec4(c, 1.0);
}`;

function Hn(e) {
    return new r(`psx`, `aftersPsx`, [], null, 1, e, S.NEAREST_SAMPLINGMODE)
}
var Kn = class {
    canvas;
    quality;
    engine;
    scene;
    camera;
    spec;
    pipeline;
    exposure = 1.05;
    constructor(t, n) {
        this.canvas = t, this.quality = n, this.spec = Un[n],         this.engine = new u(t, !1, {
            antialias: !1,
            stencil: !0,
            powerPreference: `high-performance`,
            // Needed so character-select can blit the preview scene off this canvas.
            preserveDrawingBuffer: !0
        }, !1), this.engine.enableOfflineSupport = !1;
        let r = new ie(this.engine);
        this.scene = r, r.clearColor = new o(.02, .025, .04, 1), r.ambientColor = X(.2, .22, .26), r.fogMode = ie.FOGMODE_EXP2, r.fogDensity = .02, r.fogColor = X(.05, .06, .09), r.skipPointerMovePicking = r.skipPointerDownPicking = r.skipPointerUpPicking = !0, this.camera = new e(`cam`, new T(0, 2, -160), r), this.camera.minZ = .08, this.camera.maxZ = 420, this.camera.inputs.clear();
        let a = new i(`post`, !0, r, [this.camera]),
            low = n === `low`;
        a.bloomEnabled = !low, a.bloomThreshold = .72, a.bloomWeight = .35, a.bloomKernel = this.spec.bloomKernel, a.bloomScale = .5;
        let s = a.imageProcessing;
        s.toneMappingEnabled = !0, s.toneMappingType = l.TONEMAPPING_ACES, s.exposure = this.exposure, s.contrast = 1.06, s.vignetteEnabled = !0, s.vignetteWeight = low ? 1.4 : 2.2, s.vignetteStretch = .4, s.vignetteColor = new o(0, 0, 0, 0), s.vignetteBlendMode = l.VIGNETTEMODE_MULTIPLY, this.pipeline = a, low || Hn(this.camera), this.resize()
    }
    resize() {
        this.engine.resize();
        let e = this.canvas.clientWidth || window.innerWidth,
            t = this.canvas.clientHeight || window.innerHeight;
        this.engine.setHardwareScalingLevel(Math.max(1, Math.min(e, t) / this.spec.lines)), zn.width = this.engine.getRenderWidth(), zn.height = this.engine.getRenderHeight()
    }
    setExposure(e) {
        this.exposure = e
    }
    tickPost() {
        let e = this.pipeline.imageProcessing;
        Math.abs(e.exposure - this.exposure) > this.exposure * .005 && (e.exposure = this.exposure)
    }
};

function qn(e) {
    let t = e >>> 0;
    return () => {
        t = t + 1831565813 >>> 0;
        let e = t;
        return e = Math.imul(e ^ e >>> 15, e | 1), e ^= e + Math.imul(e ^ e >>> 7, e | 61), ((e ^ e >>> 14) >>> 0) / 4294967296
    }
}

function Jn(e, t, r) {
    let i = r.segments ?? 64,
        a = [];
    for (let e = 0; e < i; e++) a.push(e / i * Math.PI * 2);
    for (let [e, t] of [
            [r.x1, r.y1],
            [r.x0, r.y1],
            [r.x0, r.y0],
            [r.x1, r.y0]
        ]) a.push((Math.atan2(t - r.cy, e - r.cx) + Math.PI * 2) % (Math.PI * 2));
    a.sort((e, t) => e - t);
    let o = [],
        s = [],
        c = [],
        l = [],
        u = e => {
            let t = Math.cos(e),
                n = Math.sin(e),
                i = 1 / 0;
            return t > 1e-9 && (i = Math.min(i, (r.x1 - r.cx) / t)), t < -1e-9 && (i = Math.min(i, (r.x0 - r.cx) / t)), n > 1e-9 && (i = Math.min(i, (r.y1 - r.cy) / n)), n < -1e-9 && (i = Math.min(i, (r.y0 - r.cy) / n)), [r.cx + t * i, r.cy + n * i]
        };
    for (let e of [0, 1]) {
        let t = e === 0 ? 0 : r.depth,
            n = e === 0 ? -1 : 1,
            i = o.length / 3;
        for (let e of a) {
            let i = r.cx + Math.cos(e) * r.r,
                a = r.cy + Math.sin(e) * r.r,
                [l, d] = u(e);
            o.push(i, a, t, l, d, t), s.push(0, 0, n, 0, 0, n), c.push(i * .25, a * .25, l * .25, d * .25)
        }
        let d = a.length;
        for (let t = 0; t < d; t++) {
            let n = i + t * 2,
                r = i + (t + 1) % d * 2;
            e === 0 ? l.push(n, r, n + 1, r, r + 1, n + 1) : l.push(n, n + 1, r, r, n + 1, r + 1)
        }
    }
    let d = o.length / 3;
    for (let e = 0; e <= i; e++) {
        let t = e / i * Math.PI * 2,
            n = r.cx + Math.cos(t) * r.r,
            a = r.cy + Math.sin(t) * r.r;
        o.push(n, a, 0, n, a, r.depth), s.push(-Math.cos(t), -Math.sin(t), 0, -Math.cos(t), -Math.sin(t), 0);
        let l = e / i * r.r * Math.PI * 2 * .25;
        c.push(l, 0, l, r.depth * .25)
    }
    for (let e = 0; e < i; e++) {
        let t = d + e * 2;
        l.push(t, t + 1, t + 2, t + 2, t + 1, t + 3)
    }
    let f = (e, t, n, i, a, u) => {
        let d = o.length / 3;
        o.push(e, t, 0, n, i, 0, e, t, r.depth, n, i, r.depth);
        for (let e = 0; e < 4; e++) s.push(a, u, 0);
        let f = Math.hypot(n - e, i - t) * .25;
        c.push(0, 0, f, 0, 0, r.depth * .25, f, r.depth * .25), a + u > 0 ? l.push(d, d + 2, d + 1, d + 1, d + 2, d + 3) : l.push(d, d + 1, d + 2, d + 1, d + 3, d + 2)
    };
    f(r.x0, r.y1, r.x1, r.y1, 0, 1), f(r.x0, r.y0, r.x0, r.y1, -1, 0), f(r.x1, r.y0, r.x1, r.y1, 1, 0);
    let p = new n;
    p.positions = o, p.normals = s, p.uvs = c, p.indices = l;
    let m = new w(e, t);
    return p.applyToMesh(m), m
}

function Yn(e, t, r, i, a, o = 1) {
    let s = [];
    for (let e = 0; e < r.length - 1; e++) {
        let [t, n] = r[e], [i, a] = r[e + 1], c = Math.hypot(i - t, a - n), l = Math.max(1, Math.ceil(c / o));
        for (let e = 0; e < l; e++) s.push([t + (i - t) * e / l, n + (a - n) * e / l])
    }
    s.push(r[r.length - 1]);
    let c = [],
        l = [],
        u = [],
        d = [],
        f = 0;
    for (let e = 0; e < s.length; e++) {
        let [t, n] = s[e], [r, o] = s[Math.max(0, e - 1)], [p, m] = s[Math.min(s.length - 1, e + 1)], h = p - r, g = m - o, _ = Math.hypot(h, g) || 1;
        h /= _, g /= _;
        let v = i * (.85 + .3 * Math.sin(e * 1.7) * Math.sin(e * .43)),
            y = -g * v * .5,
            b = h * v * .5;
        if (e > 0 && (f += Math.hypot(t - s[e - 1][0], n - s[e - 1][1])), c.push(t - y, a, n - b, t + y, a, n + b), l.push(0, 1, 0, 0, 1, 0), u.push(0, f / i, 1, f / i), e > 0) {
            let t = (e - 1) * 2;
            d.push(t, t + 2, t + 1, t + 1, t + 2, t + 3)
        }
    }
    let p = new n;
    p.positions = c, p.normals = l, p.uvs = u, p.indices = d;
    let m = new w(e, t);
    return p.applyToMesh(m), m
}

function Xn(e, t, n) {
    let r = e.getVerticesData(a.UVKind);
    if (!r) return e;
    for (let e = 0; e < r.length; e += 2) r[e] *= t, r[e + 1] *= n;
    return e.setVerticesData(a.UVKind, r), e
}

function Zn(e, t) {
    let r = e.getVerticesData(a.PositionKind);
    t(r);
    let i = new Float32Array(r.length);
    return n.ComputeNormals(r, e.getIndices(), i), e.setVerticesData(a.PositionKind, r), e.setVerticesData(a.NormalKind, i), e.refreshBoundingInfo(), e
}

function Qn(e, t = () => !1) {
    let n = new Map,
        r = [];
    for (let i of e) {
        if (t(i) || !i.material || i.parent || i.hasThinInstances || i.getChildMeshes().length || !i.isEnabled(!1) || i.visibility !== 1) {
            r.push(i);
            continue
        }
        let e = `${i.material.uniqueId}|${i.getVerticesDataKinds().sort().join(`,`)}`,
            a = n.get(e);
        a ? a.push(i) : n.set(e, [i])
    }
    for (let e of n.values()) {
        if (e.length < 2) {
            r.push(...e);
            continue
        }
        let t = `${e[0].name}-merged`,
            n = w.MergeMeshes(e, !0, !0);
        if (!n) {
            r.push(...e);
            continue
        }
        n.name = t, n.freezeWorldMatrix(), r.push(n)
    }
    return r
}

function Z(e, t, n) {
    let r = new h(t, e);
    return n.color && (r.diffuseColor = n.color), n.texture && (r.diffuseTexture = n.texture), n.bump && (r.bumpTexture = n.bump, n.bumpLevel !== void 0 && (r.bumpTexture.level = n.bumpLevel)), n.specular !== void 0 && (r.specularColor = typeof n.specular == `number` ? new g(n.specular, n.specular, n.specular) : n.specular), n.gloss !== void 0 && (r.specularPower = n.gloss), n.emissive && (r.emissiveColor = n.emissive), n.unlit && (r.disableLighting = !0), n.sides && (r.backFaceCulling = !1, r.twoSidedLighting = n.sides === `lit`), n.alpha !== void 0 && (r.alpha = n.alpha), n.blendTexture && (r.useAlphaFromDiffuseTexture = !0), n.alphaCutOff !== void 0 && (r.alphaCutOff = n.alphaCutOff), n.zOffset !== void 0 && (r.zOffset = n.zOffset), n.lights !== void 0 && (r.maxSimultaneousLights = n.lights), r
}

function $n(e, t, n, r, i) {
    let a = new te(t, n, e);
    return a.diffuse = r.clone(), a.specular = r.scale(i.shine ?? .6), a.intensity = i.intensity, a.range = i.range, a
}

function er(e, t, n, r, i) {
    let a = new ee(t, T.Up(), e);
    return a.diffuse = n.clone(), a.groundColor = r.clone(), a.specular = g.Black(), a.intensity = i, a
}
var tr = `
float hash3(vec3 p) { p = fract(p * 0.3183099 + 0.1); p *= 17.0; return fract(p.x * p.y * p.z * (p.x + p.y + p.z)); }
float noise3(vec3 x) {
  vec3 i = floor(x); vec3 f = fract(x); f = f * f * (3.0 - 2.0 * f);
  return mix(mix(mix(hash3(i), hash3(i + vec3(1,0,0)), f.x), mix(hash3(i + vec3(0,1,0)), hash3(i + vec3(1,1,0)), f.x), f.y),
             mix(mix(hash3(i + vec3(0,0,1)), hash3(i + vec3(1,0,1)), f.x), mix(hash3(i + vec3(0,1,1)), hash3(i + vec3(1,1,1)), f.x), f.y), f.z);
}`;

function nr(e, t, n, r, i, a) {
    let o = new fe(t, e, {
        vertex: n,
        fragment: n
    }, {
        attributes: i,
        uniforms: a,
        needAlphaBlending: !0
    });
    return o.alphaMode = r === `add` ? u.ALPHA_ADD : u.ALPHA_COMBINE, o.backFaceCulling = !1, o.disableDepthWrite = !0, o
}
s.ShadersStore.aftersMistVertexShader = `
precision highp float;
attribute vec3 position;
uniform mat4 world;
uniform mat4 viewProjection;
varying vec3 vPosW;
void main() {
  vec4 p = world * vec4(position, 1.0);
  vPosW = p.xyz;
  gl_Position = viewProjection * p;
}`, s.ShadersStore.aftersMistFragmentShader = `
precision highp float;
varying vec3 vPosW;
uniform vec3 cameraPosition;
uniform vec3 color;
uniform float alpha;
uniform float time;
uniform float scale;
uniform float thick;
uniform float fogDensity;
uniform vec3 playerPos;
uniform vec4 bounds;
${tr}
void main() {
  vec3 V = cameraPosition - vPosW;
  float dist = length(V);
  V /= max(dist, 0.001);
  float across = clamp(thick / (abs(V.y) + 0.06), 0.0, 1.0);
  vec3 q = vec3(vPosW.x * scale + time * 0.045, time * 0.02, vPosW.z * scale - time * 0.03);
  float n = noise3(q) * 0.65 + noise3(q * 2.3 + 7.1) * 0.35;
  float patchy = smoothstep(0.28, 0.78, n);
  float near = smoothstep(1.5, 7.0, dist) * smoothstep(1.2, 4.0, length(vPosW.xz - playerPos.xz));
  // Fade out towards the edges so the sheet never ends in a line against a wall.
  float edge = min(min(vPosW.x - bounds.x, bounds.y - vPosW.x), min(vPosW.z - bounds.z, bounds.w - vPosW.z));
  near *= smoothstep(0.0, 4.0, edge);
  float seen = exp(-pow(fogDensity * dist * 0.7, 2.0));
  gl_FragColor = vec4(color, min(1.0, alpha * patchy * across * near * (0.35 + 0.65 * seen)));
}`, s.ShadersStore.aftersShaftVertexShader = `
precision highp float;
attribute vec3 position;
attribute vec3 normal;
attribute vec2 uv;
uniform mat4 world;
uniform mat4 viewProjection;
varying vec3 vPosW;
varying vec3 vNormalW;
varying float vT;
varying float vK;
void main() {
  vec4 p = world * vec4(position, 1.0);
  vPosW = p.xyz;
  vNormalW = normalize(mat3(world) * normal);
  // All the shafts are one mesh: uv.x is a shaft's brightness, uv.y how far up it a vertex is.
  vT = uv.y;
  vK = uv.x;
  gl_Position = viewProjection * p;
}`, s.ShadersStore.aftersShaftFragmentShader = `
precision highp float;
varying vec3 vPosW;
varying vec3 vNormalW;
varying float vT;
varying float vK;
uniform vec3 cameraPosition;
uniform vec3 color;
uniform float time;
uniform float fogDensity;
${tr}
void main() {
  float t = clamp(vT, 0.0, 1.0);
  float along = smoothstep(0.0, 0.08, t) * pow(1.0 - t, 1.6);
  vec3 V = cameraPosition - vPosW;
  float dist = length(V);
  V /= max(dist, 0.001);
  float facing = abs(dot(normalize(vNormalW), V));
  float soft = pow(facing, 2.2);
  float haze = 0.4 + 0.6 * noise3(vPosW * 0.55 + vec3(time * 0.08, -time * 0.05, time * 0.04));
  float seen = exp(-pow(fogDensity * dist * 0.8, 2.0)) * smoothstep(2.0, 9.0, dist);
  gl_FragColor = vec4(color * vK * along * soft * haze * seen, 1.0);
}`;
var rr = class {
        onDrip = () => void 0;
        woodsMist = [];
        clubMist = [];
        shafts;
        drops = [];
        t = 0;
        dripIn = 0;
        rng = qn(8080);
        constructor(e, n, r) {
            let i = (n, r, i, a, o, s, c, l) => {
                    let u = nr(e, `${n}-mat`, `aftersMist`, `mix`, [`position`], [`world`, `viewProjection`, `cameraPosition`, `color`, `alpha`, `time`, `scale`, `thick`, `fogDensity`, `playerPos`, `bounds`]);
                    u.setFloat(`alpha`, s), u.setFloat(`scale`, c), u.setFloat(`thick`, .18), u.setColor3(`color`, dn), u.setVector4(`bounds`, new t(o.x - r / 2, o.x + r / 2, o.z - i / 2, o.z + i / 2));
                    let d = y(n, {
                        width: r,
                        height: i,
                        subdivisionsX: a[0],
                        subdivisionsY: a[1]
                    }, e);
                    return d.position.copyFrom(o), l && Zn(d, e => {
                        for (let t = 0; t < e.length; t += 3) e[t + 1] = l(e[t] + o.x, e[t + 2] + o.z)
                    }), d.material = u, d.alphaIndex = 10, {
                        mesh: d,
                        mat: u,
                        alpha: s
                    }
                },
                o = H.zMin - 14,
                s = -79.3,
                c = new T(0, 0, (o + s) / 2),
                l = r < .6 ? [
                    [.4, .22, .06],
                    [1.2, .12, .04]
                ] : [
                    [.25, .15, .07],
                    [.6, .12, .055],
                    [1, .09, .045],
                    [1.5, .06, .035]
                ];
            for (let [e, t, n] of l) this.woodsMist.push(i(`woods-mist-${e}`, (H.xMax + 14) * 2, s - o, [70, 60], c, t * Math.min(1.2, .5 + r * .5), n, (t, n) => Ut(t, n) + e));
            let u = W.xMax - W.xMin - .6,
                d = W.zMax - W.zMin - .6,
                f = (W.zMin + W.zMax) / 2;
            this.clubMist.push(i(`club-ceiling-haze`, u, d, [2, 2], new T(0, W.height - 1.1, f), .3, .07)), this.clubMist.push(i(`club-ceiling-haze-2`, u, d, [2, 2], new T(0, W.height - 2.1, f), .16, .05));
            let m = n.scale(-1).add(new T(0, 1.1, 0)).normalize(),
                h = p.FromUnitVectorsToRef(T.Up(), m, new p),
                g = [],
                _ = qn(4711);
            for (let e = 0; e < q.length - 1; e++) {
                let [t, n] = q[e], [r, i] = q[e + 1], a = Math.max(1, Math.round(Math.hypot(r - t, i - n) / 11));
                for (let e = 0; e < a; e++) {
                    let o = (e + .3 + _() * .4) / a,
                        s = _() < .5 ? -1 : 1,
                        c = t + (r - t) * o + s * (3 + _() * 6),
                        l = n + (i - n) * o;
                    l > -82 || Math.hypot(c - J.x, l - J.z) < 4 || g.push([c, l, 1.1 + _() * 1.3])
                }
            }
            g.push([-6, -92, 2.6], [7.5, -98, 1.8]);
            let v = nr(e, `moon-shaft`, `aftersShaft`, `add`, [`position`, `normal`, `uv`], [`world`, `viewProjection`, `cameraPosition`, `color`, `time`, `fogDensity`]);
            v.setColor3(`color`, rn);
            let b = g.map(([t, n, r]) => {
                    let i = x(`moon-shaft`, {
                            height: 26,
                            diameterBottom: r * 1.5,
                            diameterTop: r * 3,
                            tessellation: 20,
                            cap: w.NO_CAP
                        }, e),
                        o = .4 + _() * .35,
                        s = i.getVerticesData(a.PositionKind),
                        c = new Float32Array(s.length / 3 * 2);
                    for (let e = 0; e < s.length / 3; e++) c[e * 2] = o, c[e * 2 + 1] = s[e * 3 + 1] / 26 + .5;
                    return i.setVerticesData(a.UVKind, c), i.rotationQuaternion = h.clone(), i.position.copyFrom(new T(t, Ut(t, n) - .3, n).add(m.scale(13))), i
                }),
                ee = w.MergeMeshes(b, !0, !0);
            ee.name = `moon-shafts`, ee.material = v, ee.alphaIndex = 20, this.shafts = {
                mesh: ee,
                mat: v
            };
            let te = oe(`drip`, {
                diameter: .03,
                segments: 4
            }, e);
            te.scaling.y = 4, te.material = Z(e, `drip-mat`, {
                unlit: !0,
                emissive: X(.42, .47, .52),
                alpha: .75
            }), te.setEnabled(!1);
            let ne = ce(`ripple`, {
                diameter: .12,
                thickness: .006,
                tessellation: 20
            }, e);
            ne.material = Z(e, `ripple-mat`, {
                unlit: !0,
                emissive: X(.4, .45, .5),
                alpha: .5
            }), ne.setEnabled(!1);
            for (let e = 0; e < 14; e++) {
                let t = e === 0 ? te : te.clone(`drip-${e}`),
                    n = e === 0 ? ne : ne.clone(`ripple-${e}`);
                this.drops.push({
                    mesh: t,
                    ripple: n,
                    vy: 0,
                    floor: 0,
                    t: 0,
                    state: `idle`,
                    where: `pipe`
                })
            }
        }
        update(e, t) {
            this.t += e;
            let n = e => {
                    e.setVector3(`cameraPosition`, t.camera), e.setFloat(`time`, this.t), e.setFloat(`fogDensity`, t.fogDensity)
                },
                r = (e, r, i, a) => {
                    for (let {
                            mesh: o,
                            mat: s,
                            alpha: c
                        }
                        of e) o.setEnabled(r), r && (n(s), s.setVector3(`playerPos`, t.player), s.setColor3(`color`, t.fogColor.scale(i)), s.setFloat(`alpha`, c * a))
                };
            r(this.woodsMist, t.live.forest, 1.35, 1), r(this.clubMist, t.live.club, 1.25, t.reveal), this.shafts.mesh.setEnabled(t.live.forest), t.live.forest && n(this.shafts.mat), this.updateDrips(e, t.player, t.live)
        }
        updateDrips(e, t, n) {
            let r = n.pipe && t.z > U.zStart - 12 && t.z < U.zEnd + 4,
                i = n.club && t.z > W.zMin - 2;
            if (this.dripIn -= e, this.dripIn <= 0 && (r || i)) {
                this.dripIn = r ? .25 + this.rng() * .6 : .9 + this.rng() * 1.6;
                let e = this.drops.find(e => e.state === `idle`);
                if (e) {
                    let n, i, a;
                    r ? (n = (this.rng() - .5) * 3.2, a = E(t.z + (this.rng() - .3) * 26, U.zStart + .5, U.zEnd - .5), i = U.centerY + Math.sqrt(U.radius * U.radius - n * n) - .12, e.floor = Math.abs(n) < .55 ? .015 : .005, e.where = `pipe`) : (n = E(t.x + (this.rng() - .5) * 18, W.xMin + 1, W.xMax - 1), a = E(t.z + (this.rng() - .3) * 18, W.zMin + 1, W.zMax - 1), i = W.height - .1, e.floor = .01, e.where = `hall`), e.mesh.position.set(n, i, a), e.mesh.setEnabled(!0), e.ripple.setEnabled(!1), e.vy = 0, e.state = `fall`
                }
            }
            for (let t of this.drops)
                if (t.state === `fall`) t.vy -= 9.8 * e, t.mesh.position.y += t.vy * e, t.mesh.position.y <= t.floor && (t.mesh.setEnabled(!1), t.ripple.position.set(t.mesh.position.x, t.floor + .005, t.mesh.position.z), t.ripple.scaling.setAll(1), t.ripple.visibility = 1, t.ripple.setEnabled(!0), t.state = `ripple`, t.t = 0, this.onDrip(t.ripple.position, t.where));
                else if (t.state === `ripple`) {
                t.t += e;
                let n = t.t / .7;
                t.ripple.scaling.set(1 + n * 5, 1, 1 + n * 5), t.ripple.visibility = Math.max(0, 1 - n), n >= 1 && (t.ripple.setEnabled(!1), t.state = `idle`)
            }
        }
    },
    ir = 70,
    ar = .8,
    or = Math.PI / 180,
    sr = .3,
    cr = .2,
    lr = 1.35,
    ur = class {
        cam;
        yaw = 0;
        pitch = .22;
        firstPerson = !1;
        eyePitch = 0;
        through = 0;
        pos = new T(0, 2, -160);
        look = new T(0, 1.5, -150);
        target = new T;
        lookAt = new T;
        eyeLook = new T;
        at = new T;
        aim = new T;
        trauma = 0;
        t = 0;
        fovKick = 0;
        portrait = 0;
        constructor(e) {
            this.cam = e
        }
        addTrauma(e) {
            this.trauma = Math.min(1, this.trauma + e)
        }
        turn(e, t) {
            this.yaw += e, this.firstPerson ? this.eyePitch = E(this.eyePitch + t, -1.35, lr) : this.pitch = E(this.pitch + t, -.35, 1.1)
        }
        toggleView() {
            this.firstPerson = !this.firstPerson, this.firstPerson ? this.eyePitch = E(this.pitch - cr, -1.35, lr) : this.pitch = E(this.eyePitch + cr, -.35, 1.1)
        }
        get inHead() {
            return this.through > .8
        }
        snapBehind(e, t) {
            this.yaw = t, this.pitch = .2, this.eyePitch = 0, this.pos.set(e.x - Math.sin(t) * 4.5, e.y + 2.3, e.z - Math.cos(t) * 4.5), this.look.set(e.x, e.y + 1.5, e.z)
        }
        follow(e, t, n) {
            let r = be(t - this.yaw);
            n < 1 || Math.abs(r) > 2.3 || (this.yaw += r * Math.min(1, e * .9 * Math.min(1, n / 3)))
        }
        update(e, t) {
            this.t += e;
            let n = D((t.speed - 3.6) / 2.6),
                r = D((1 - t.aspect) / .5);
            this.portrait = r;
            let i = 2 * Math.atan(Math.tan(56 * or / 2) / Math.min(1, t.aspect)) / or,
                a = Math.min(92, Math.max(ir, i)),
                o = 4.1 + n * .7 + r * .9,
                s = Math.cos(this.pitch),
                c = .45 * (1 - r),
                l = Math.cos(this.yaw),
                u = -Math.sin(this.yaw),
                d = this.target.set(t.player.x - Math.sin(this.yaw) * s * o + l * c, t.player.y + 1.55 + Math.sin(this.pitch) * o, t.player.z - Math.cos(this.yaw) * s * o + u * c);
            this.constrain(d, t.player);
            let f = this.lookAt.set(t.player.x + l * c * .6, t.player.y + 1.45, t.player.z + u * c * .6),
                p = 1 - Math.exp(-e * 12);
            this.pos.addInPlace(d.subtract(this.pos).scaleInPlace(p)), this.look.addInPlace(f.subtract(this.look).scaleInPlace(Math.min(1, p * 1.5))), this.fovKick = A(this.fovKick, n * 7, 4, e), this.through = D(this.through + (this.firstPerson ? e : -e) / sr);
            let m = O(this.through),
                h = Math.cos(this.eyePitch) * 4;
            this.eyeLook.set(t.eye.x + Math.sin(this.yaw) * h, t.eye.y - Math.sin(this.eyePitch) * 4, t.eye.z + Math.cos(this.yaw) * h);
            let g = T.LerpToRef(this.pos, t.eye, m, this.at),
                _ = T.LerpToRef(this.look, this.eyeLook, m, this.aim);
            this.trauma = Math.max(0, this.trauma - e * 1.4);
            let v = this.trauma * this.trauma * ar,
                y = e => Math.sin(this.t * e) * Math.sin(this.t * e * 1.37 + 1.3);
            this.cam.position.set(g.x + y(37) * v * .18, g.y + y(41) * v * .14, g.z + y(29) * v * .18), this.cam.setTarget(new T(_.x + y(23) * v * .1, _.y + y(31) * v * .1, _.z)), this.cam.fov = (a + this.fovKick + v * 4) * or
        }
        constrain(e, t) {
            let n = Rt(t.z),
                r = U.radius - .45,
                i = e.y - U.centerY,
                a = Math.hypot(e.x, i),
                o = e.z > U.zStart - 1.3 && e.z < U.zEnd + .7;
            n === `pipe` || o && a <= r ? (a > r && (e.x *= r / a, e.y = U.centerY + i * r / a), e.y = Math.max(.5, e.y)) : n === `club` ? (e.x = E(e.x, W.xMin + .5, W.xMax - .5), e.z = E(e.z, W.zMin + .4, W.zMax - .5), e.y = E(e.y, 2.7 + this.portrait * .9, W.height - .6)) : (e.x = E(e.x, H.xMin - 5, H.xMax + 5), e.y = Math.max(Ut(e.x, e.z) + .5, e.y), e.z > U.zStart - 1.5 && a > r && (e.z = U.zStart - 1.5))
        }
        get position() {
            return this.cam.position
        }
        forward(e) {
            return this.cam.getDirectionToRef(T.Forward(), e), e
        }
    },
    dr = 49 / 4,
    fr = (Le + 1) * 16,
    pr = null;

function mr(e) {
    if (pr) return pr;
    let t = new b(`dance-rig`, `dance-rig`, e),
        n = [];
    for (let e = 0; e < Le; e++) {
        let r = Re[e],
            i = ze[e],
            a = r >= 0 ? ze[r] : [0, 0, 0];
        n.push(new ae(Ie[e], t, r >= 0 ? n[r] : null, c.Translation(i[0] - a[0], i[1] - a[1], i[2] - a[2])))
    }
    return pr = t, t
}

function hr(e) {
    let t = rt.length * 49,
        n = new Float32Array(fr * t),
        r = Be(),
        i = {},
        a = c.Identity().m,
        o = 0;
    for (let e of rt) {
        i[e] = [o, o + 49 - 1];
        for (let t = 0; t < 49; t++) {
            ct(e, ye((t - .5) / 12, 4), r);
            let i = o * fr;
            Xe(r, n, i), n.set(a, i + Le * 16), o++
        }
    }
    let s = me.CreateRGBATexture(n, (Le + 1) * 4, t, e, !1, !1, S.NEAREST_NEAREST, u.TEXTURETYPE_FLOAT);
    return s.name = `crowd-vat`, {
        texture: s,
        ranges: i
    }
}
var gr = class {
        mesh;
        pose = Be();
        skin = new Float32Array(fr);
        texture;
        constructor(e) {
            this.mesh = e, this.texture = me.CreateRGBATexture(this.skin, (Le + 1) * 4, 1, e.getScene(), !1, !1, S.NEAREST_NEAREST, u.TEXTURETYPE_FLOAT);
            let t = new ue(e.getScene());
            t.texture = this.texture, e.bakedVertexAnimationManager = t, e.thinInstanceRegisterAttribute(`bakedVertexAnimationSettingsInstanced`, 4), e.thinInstanceAddSelf(), e.thinInstanceSetAttributeAt(`bakedVertexAnimationSettingsInstanced`, 0, [0, 0, 0, 0]), e.alwaysSelectAsActiveMesh = !0, this.commit()
        }
        commit() {
            Xe(this.pose, this.skin), this.texture.update(this.skin)
        }
        dispose() {
            try {
                this.mesh.material?.dispose?.( !0, !0)
            } catch {}
            try {
                this.texture?.dispose?.()
            } catch {}
            try {
                this.mesh.dispose?.( !1, !0)
            } catch {}
        }
    },
    _r = `characters/`;
async function vr(e, preferred = null) {
    let t = (await (await fetch(`${_r}index.json`)).json()).characters.slice();
    for (let e = t.length - 1; e > 0; e--) {
        let n = Math.floor(Math.random() * (e + 1));
        [t[e], t[n]] = [t[n], t[e]]
    }
    if (preferred) {
        let n = t.findIndex(e => e.name === preferred);
        n > 0 && t.unshift(t.splice(n, 1)[0])
    }
    return t.slice(0, e)
}

function yr(e) {
    let t = new Uint32Array(e, 0, 2),
        r = t[0],
        i = t[1],
        a = 8,
        o = (t, n) => {
            let r = new t(e, a, n);
            return a += Math.ceil(n * t.BYTES_PER_ELEMENT / 4) * 4, r
        },
        s = o(Int16Array, r * 3),
        c = o(Int8Array, r * 4),
        l = o(Uint16Array, r * 2),
        u = o(Uint8Array, r * 4),
        d = o(Uint8Array, r * 4),
        f = o(Uint16Array, i),
        p = new n,
        m = new Float32Array(r * 3),
        h = new Float32Array(r * 3),
        g = new Float32Array(r * 2),
        _ = new Float32Array(r * 4),
        v = new Float32Array(r * 4);
    for (let e = 0; e < r; e++) {
        for (let t = 0; t < 3; t++) m[e * 3 + t] = s[e * 3 + t] / 1e3, h[e * 3 + t] = c[e * 4 + t] / 127;
        g[e * 2] = l[e * 2] / 65535, g[e * 2 + 1] = l[e * 2 + 1] / 65535;
        for (let t = 0; t < 4; t++) _[e * 4 + t] = u[e * 4 + t], v[e * 4 + t] = d[e * 4 + t] / 255
    }
    return p.positions = m, p.normals = h, p.uvs = g, p.matricesIndices = _, p.matricesWeights = v, p.indices = Uint32Array.from(f), p
}
async function loadCharacterAsset(scene, meta) {
    let a = await (await fetch(`${_r}${meta.name}.bin`)).arrayBuffer(),
        o = await new Promise(n => {
            let r = new S(`${_r}${meta.name}.png`, scene, {
                noMipmap: !1,
                invertY: !1,
                samplingMode: S.NEAREST_NEAREST_MIPNEAREST,
                onLoad: () => n(r),
                onError: () => n(r)
            })
        });
    return o.wrapU = o.wrapV = S.CLAMP_ADDRESSMODE, {
        name: meta.name,
        sex: meta.sex,
        data: yr(a),
        texture: o
    }
}
async function br(e, t, n, preferred = null) {
    let r = await vr(t, preferred),
        i = 0;
    return Promise.all(r.map(async t => {
        let a = await loadCharacterAsset(e, t);
        return n(++i / r.length), a
    }))
}

function xr(e, t, n) {
    let r = new w(e, t);
    return n.data.applyToMesh(r, !1), r.skeleton = mr(t), r.numBoneInfluencers = 4, r.doNotSyncBoundingInfo = !0, r
}

function Sr(e, t, n, r = .14, i = 6) {
    return Z(t, e, {
        texture: n.texture,
        specular: Zt,
        emissive: X(r, r, r * 1.08),
        lights: i
    })
}

/**
 * Character-select dancing preview.
 * Shares the main game Engine (second WebGL contexts stay blank on many GPUs).
 * Each frame: render preview scene → blit to hero canvas → main scene renders after.
 */
function createCharacterPreview(canvas, stage) {
    const host = canvas.parentElement || canvas,
        engine = stage.engine,
        mainCanvas = stage.canvas,
        scene = new ie(engine);
    scene.clearColor = new o(.07, .08, .1, 1);
    scene.ambientColor = X(.55, .56, .6);
    scene.fogMode = ie.FOGMODE_NONE;
    scene.autoClear = !0;
    scene.skipPointerMovePicking = scene.skipPointerDownPicking = scene.skipPointerUpPicking = !0;

    let hemi = new ee(`prev-hemi`, new T(0, 1, .2), scene);
    hemi.diffuse = X(.85, .88, .95);
    hemi.groundColor = X(.22, .2, .24);
    hemi.intensity = 1.35;
    let key = new te(`prev-key`, new T(.55, -1, .4), scene);
    key.diffuse = X(1, .96, .9);
    key.intensity = 1.65;
    let fill = new te(`prev-fill`, new T(-.6, -.2, -.5), scene);
    fill.diffuse = X(.45, .55, .75);
    fill.intensity = .7;

    let cam = new e(`prev-cam`, new T(0, 1.2, -3.4), scene);
    cam.minZ = .05;
    cam.maxZ = 40;
    cam.fov = .8;
    cam.setTarget(new T(0, .95, 0));
    cam.inputs.clear();
    scene.activeCamera = cam;

    let ctx = null;
    try {
        ctx = canvas.getContext(`2d`, {
            alpha: !1
        })
    } catch {
        ctx = canvas.getContext(`2d`)
    }

    let avatar = null,
        gen = 0,
        dance = rt[Math.floor(Math.random() * rt.length)],
        danceT = 0,
        nextDanceIn = 2.5 + Math.random() * 2,
        yaw = Math.PI * .85,
        last = performance.now(),
        disposed = !1,
        loading = null,
        cssW = 0,
        cssH = 0;

    function pickDance() {
        let n = rt[Math.floor(Math.random() * rt.length)];
        for (let i = 0; i < 4 && n === dance; i++) n = rt[Math.floor(Math.random() * rt.length)];
        dance = n;
        danceT = 0;
        nextDanceIn = 2.8 + Math.random() * 2.4
    }

    function syncCanvasSize() {
        const rect = host.getBoundingClientRect(),
            w = Math.max(2, Math.floor(rect.width || host.clientWidth || 320)),
            h = Math.max(2, Math.floor(rect.height || host.clientHeight || 320)),
            dpr = Math.min(window.devicePixelRatio || 1, 2),
            bw = Math.max(2, Math.floor(w * dpr)),
            bh = Math.max(2, Math.floor(h * dpr));
        cssW = w;
        cssH = h;
        if (canvas.width !== bw || canvas.height !== bh) {
            canvas.width = bw;
            canvas.height = bh
        }
        canvas.style.width = `${w}px`;
        canvas.style.height = `${h}px`;
        return { w, h, bw, bh }
    }
    syncCanvasSize();

    let onResize = () => {
        if (!disposed) syncCanvasSize()
    };
    window.addEventListener(`resize`, onResize);
    let ro = null;
    try {
        ro = new ResizeObserver(onResize);
        ro.observe(host)
    } catch {}
    requestAnimationFrame(onResize);

    return {
        /** Called from the main render loop BEFORE the game scene renders. */
        renderFrame() {
            if (disposed || !ctx) return;
            let now = performance.now(),
                dt = Math.min(.05, (now - last) / 1e3);
            last = now;
            if (avatar) {
                danceT += dt;
                nextDanceIn -= dt;
                nextDanceIn <= 0 && pickDance();
                yaw += dt * .55;
                ct(dance, danceT, avatar.pose);
                avatar.mesh.rotation.y = yaw;
                avatar.mesh.position.set(0, 0, 0);
                avatar.commit()
            }
            try {
                scene.render();
                syncCanvasSize();
                // Crop to hero aspect so the dancer isn't stretched from the fullscreen buffer.
                const srcW = mainCanvas.width,
                    srcH = mainCanvas.height,
                    dstAspect = canvas.width / Math.max(1, canvas.height);
                let sw, sh, sx, sy;
                if (srcW / Math.max(1, srcH) > dstAspect) {
                    sh = srcH;
                    sw = srcH * dstAspect;
                } else {
                    sw = srcW;
                    sh = srcW / dstAspect
                }
                sx = (srcW - sw) * .5;
                sy = (srcH - sh) * .5;
                ctx.drawImage(mainCanvas, sx, sy, sw, sh, 0, 0, canvas.width, canvas.height)
            } catch (err) {
                console.warn(`[afters] preview blit failed`, err)
            }
        },
        async show(meta) {
            if (disposed || !meta) return;
            let my = ++gen;
            loading = meta.name;
            syncCanvasSize();
            try {
                let asset = await loadCharacterAsset(scene, meta);
                if (my !== gen || disposed) {
                    try {
                        asset.texture?.dispose?.()
                    } catch {}
                    return
                }
                let mesh = xr(`preview-${meta.name}`, scene, asset);
                mesh.material = Sr(`preview-mat-${meta.name}`, scene, asset, .38, 6);
                mesh.alwaysSelectAsActiveMesh = !0;
                mesh.isPickable = !1;
                hemi.includedOnlyMeshes = [];
                key.includedOnlyMeshes = [];
                fill.includedOnlyMeshes = [];
                let next = new gr(mesh);
                avatar && avatar.dispose();
                avatar = next;
                pickDance();
                yaw = Math.PI * .85;
                cam.position.set(0, 1.2, -3.4);
                cam.setTarget(new T(0, .95, 0))
            } catch (err) {
                console.warn(`[afters] preview failed`, err);
                throw err
            } finally {
                if (loading === meta.name) loading = null
            }
        },
        dispose() {
            if (disposed) return;
            disposed = !0;
            gen++;
            window.removeEventListener(`resize`, onResize);
            try {
                ro?.disconnect?.()
            } catch {}
            ro = null;
            try {
                avatar?.dispose?.()
            } catch {}
            avatar = null;
            try {
                scene.dispose()
            } catch {}
            try {
                ctx && ctx.clearRect(0, 0, canvas.width, canvas.height)
            } catch {}
            ctx = null
        }
    }
}
var Cr = class {
    meshes = [];
    lights = [];
    illuminate(e, t = this.lights) {
        for (let n of t) n.includedOnlyMeshes.includes(e) || n.includedOnlyMeshes.push(e)
    }
    setVisible(e) {
        for (let t of this.meshes) t.setEnabled(e)
    }
};

function wr(e, t) {
    e.isEnabled(!1) !== t && e.setEnabled(t)
}
var Tr = 1.05,
    Er = 5.75,
    Dr = class extends Cr {
        roomLights;
        washes;
        fill;
        desk;
        woofers = [];
        platters = [];
        t = 0;
        constructor(e, t) {
            super();
            let n = W.xMax - W.xMin,
                r = W.zMax - W.zMin,
                i = (W.zMin + W.zMax) / 2,
                a = W.height,
                o = qn(404),
                s = (e, t) => (e.material = t, this.meshes.push(e), e),
                l = Z(e, `club-floor-mat`, {
                    texture: t.concrete,
                    bump: t.concreteBump,
                    bumpLevel: .5,
                    color: X(.36, .38, .42),
                    specular: X(.22, .24, .28),
                    gloss: 60,
                    lights: 6
                }),
                u = Z(e, `club-wall-mat`, {
                    texture: t.concrete,
                    bump: t.concreteBump,
                    color: X(.4, .42, .46),
                    specular: X(.06, .06, .08),
                    sides: `lit`,
                    lights: 6
                }),
                d = Z(e, `club-dark-mat`, {
                    color: X(.06, .065, .075),
                    specular: X(.14, .15, .18),
                    gloss: 40,
                    lights: 6
                }),
                f = Z(e, `club-ceiling-mat`, {
                    color: X(.1, .1, .11),
                    specular: Zt,
                    sides: `both`,
                    lights: 6
                }),
                p = s(y(`club-floor`, {
                    width: n,
                    height: r
                }, e), l);
            p.position.set(0, 0, i), Xn(p, 10, 12);
            let m = s(v(`club-ceiling`, {
                width: n,
                height: r
            }, e), f);
            m.rotation.x = -Math.PI / 2, m.position.set(0, a, i);
            let h = s(v(`club-back`, {
                width: n,
                height: a
            }, e), u);
            h.position.set(0, a / 2, W.zMax), Xn(h, 8, 1.6);
            for (let t of [-1, 1]) {
                let n = s(v(`club-side-${t}`, {
                    width: r,
                    height: a
                }, e), u);
                n.rotation.y = t * Math.PI / 2, n.position.set(t < 0 ? W.xMin : W.xMax, a / 2, i), Xn(n, 9, 1.6)
            }
            let g = s(Jn(`club-front`, e, {
                x0: W.xMin,
                x1: W.xMax,
                y0: -.8,
                y1: a,
                cx: 0,
                cy: U.centerY,
                r: U.radius,
                depth: .6
            }), u);
            g.position.z = W.zMin - .6;
            let _ = s(ce(`club-drain-frame`, {
                diameter: U.radius * 2 + .3,
                thickness: .35,
                tessellation: 64
            }, e), d);
            _.rotation.x = Math.PI / 2, _.position.set(0, U.centerY, W.zMin + .05);
            for (let t of Pt) s(C(`pillar`, {
                width: t.r * 2,
                height: a,
                depth: t.r * 2
            }, e), u).position.set(t.x, a / 2, t.z);
            for (let t = W.zMin + 4; t < W.zMax; t += 7) s(C(`ceiling-beam`, {
                width: n,
                height: .5,
                depth: .45
            }, e), u).position.set(0, a - .25, t);
            s(C(`riser`, {
                width: G.xMax - G.xMin,
                height: G.top,
                depth: G.zMax - G.zMin
            }, e), d).position.set((G.xMin + G.xMax) / 2, G.top / 2, (G.zMin + G.zMax) / 2), s(C(`booth`, {
                width: K.xMax - K.xMin,
                height: K.top - G.top,
                depth: K.zMax - K.zMin
            }, e), d).position.set(0, (K.top + G.top) / 2, (K.zMin + K.zMax) / 2);
            let b = Z(e, `deck-mat`, {
                    color: X(.12, .12, .13),
                    specular: X(.5, .5, .55)
                }),
                ee = Z(e, `platter-mat`, {
                    color: X(.03, .03, .03),
                    specular: .7,
                    gloss: 120
                }),
                te = Z(e, `label-mat`, {
                    color: X(.7, .68, .62),
                    specular: Zt
                });
            for (let t of [-1.25, 1.25]) {
                s(C(`deck`, {
                    width: .9,
                    height: .12,
                    depth: .7
                }, e), b).position.set(t, K.top + .06, Er);
                let n = s(x(`platter`, {
                    height: .03,
                    diameter: .6,
                    tessellation: 32
                }, e), ee);
                n.position.set(t, K.top + .135, Er);
                let r = s(he(`label`, {
                    radius: .08,
                    tessellation: 16
                }, e), te);
                r.rotation.x = Math.PI / 2, r.position.set(.13, .017, 0), r.parent = n, this.platters.push(n)
            }
            s(C(`mixer`, {
                width: .9,
                height: .14,
                depth: .7
            }, e), b).position.set(0, K.top + .07, Er);
            let ne = Z(e, `mixer-led-mat`, {
                unlit: !0,
                emissive: X(.9, .25, .1)
            });
            for (let t = 0; t < 4; t++) s(x(`mixer-led`, {
                height: .02,
                diameter: .025,
                tessellation: 6
            }, e), ne).position.set(-.3 + t * .2, K.top + .15, 5.55);
            let re = s(oe(`desk-lamp`, {
                diameter: .08,
                segments: 6
            }, e), Z(e, `desk-lamp-mat`, {
                unlit: !0,
                emissive: X(1, .72, .42)
            }));
            re.position.set(.9, K.top + .75, 5.35), s(x(`desk-lamp-arm`, {
                height: .75,
                diameter: .02,
                tessellation: 4
            }, e), b).position.set(.9, K.top + .38, 5.4);
            let ie = Z(e, `cab-mat`, {
                    color: X(.05, .05, .055),
                    specular: X(.12, .12, .14)
                }),
                S = Z(e, `woofer-mat`, {
                    color: X(.09, .09, .1),
                    specular: X(.4, .4, .45),
                    gloss: 60
                });
            for (let t of Ft) {
                let n = s(C(`speaker`, {
                    width: t.w,
                    height: t.h,
                    depth: t.d
                }, e), ie);
                n.position.set(t.x, t.h / 2, t.z), n.rotation.y = t.yaw;
                for (let [r, i] of [
                        [.55, .72],
                        [1.45, .72],
                        [2.2, .36]
                    ]) {
                    let a = s(x(`woofer`, {
                        height: .08,
                        diameterTop: i * .25,
                        diameterBottom: i,
                        tessellation: 20
                    }, e), S);
                    a.bakeTransformIntoVertices(c.RotationX(-Math.PI / 2).multiply(c.Translation(0, 0, -.04))), a.position.set(0, r - t.h / 2, t.d / 2 + .05), a.parent = n, i > .5 && this.woofers.push(a)
                }
            }
            let ae = Z(e, `crate-mat`, {
                color: X(.14, .16, .2),
                specular: X(.1, .1, .12)
            });
            for (let [t, n] of [
                    [-13.2, -15],
                    [-13.2, -13.9],
                    [13.1, 2],
                    [12.2, 2.2],
                    [-10, -7.6],
                    [10.9, 11.2],
                    [-12.8, 14.6],
                    [13, 14.8]
                ]) {
                let r = 1 + Math.floor(o() * 3);
                for (let i = 0; i < r; i++) {
                    let r = s(C(`crate`, {
                        width: .6,
                        height: .34,
                        depth: .42
                    }, e), ae);
                    r.position.set(t + (o() - .5) * .1, .17 + i * .34, n + (o() - .5) * .1), r.rotation.y = (o() - .5) * .4
                }
            }
            let se = [new T(-7, 5.4, 2), new T(7, 5.4, 10), new T(0, 5.4, 13)];
            this.washes = se.map((t, n) => $n(e, `wash-${n}`, t, un[n], {
                intensity: .6,
                range: 30
            })), this.fill = er(e, `club-fill`, cn, en, Tr), this.desk = $n(e, `desk-lamp-light`, re.position.add(new T(0, -.1, 0)), ln, {
                intensity: 1.1,
                range: 5
            }), this.roomLights = [...this.washes, this.fill], this.lights.push(...this.roomLights, this.desk);
            let le = new Set([...this.woofers, ...this.platters]);
            this.meshes.splice(0, this.meshes.length, ...Qn(this.meshes, e => le.has(e)));
            for (let e of this.lights) e.includedOnlyMeshes = [...this.meshes]
        }
        update(e, t) {
            this.t += e;
            let n = Te(t.beat);
            this.fill.intensity = Tr * t.reveal;
            for (let e of this.woofers) e.scaling.z = 1 + t.bass * 1.4 + n * .9;
            for (let t of this.platters) t.rotation.y += e * 3.49;
            this.desk.intensity = (.9 + Math.sin(this.t * 13) * .04) * t.reveal, this.washes.forEach((e, r) => e.intensity = (.4 + Math.sin(this.t * 1.575 + r * 1.3) * .22 + t.bass * .55 + n * .2) * t.reveal)
        }
        setLightsOn(e) {
            for (let t of this.lights) wr(t, e)
        }
    },
    Or = (e, t) => (e + 512) * 4096 + (t + 512),
    kr = class {
        size;
        cells = new Map;
        spans = !1;
        constructor(e) {
            this.size = e
        }
        add(e, t, n, r = 0) {
            let i = this.size,
                [a, o, s, c] = [Math.floor((t - r) / i), Math.floor((t + r) / i), Math.floor((n - r) / i), Math.floor((n + r) / i)];
            this.spans ||= a !== o || s !== c;
            for (let t = a; t <= o; t++)
                for (let n = s; n <= c; n++) {
                    let r = this.cells.get(Or(t, n));
                    r ? r.push(e) : this.cells.set(Or(t, n), [e])
                }
        }
        near(e, t) {
            let n = Math.floor(e / this.size),
                r = Math.floor(t / this.size),
                i = [];
            for (let e = -1; e <= 1; e++)
                for (let t = -1; t <= 1; t++) i.push(...this.cells.get(Or(n + e, r + t)) ?? []);
            return this.spans ? [...new Set(i)] : i
        }
    },
    Ar = 1.25,
    jr = class {
        meshes;
        manager;
        dancers = [];
        groups;
        grid = new kr(2);
        active = new Set;
        ranges;
        hype = !1;
        leader = -1;
        visible = !0;
        constructor(e, t, n, r) {
            this.ranges = n.ranges, this.manager = new ue(e), this.manager.texture = n.texture, this.manager.time = 1e3, this.place(t);
            let i = r.map(() => 0);
            for (let e of this.dancers) e.group = Math.floor(Math.random() * r.length), e.slot = i[e.group]++;
            let a = qn(99);
            this.groups = r.map((t, n) => {
                let r = xr(`crowd-${t.name}`, e, t);
                r.material = Sr(`crowd-${t.name}-mat`, e, t), r.bakedVertexAnimationManager = this.manager, r.alwaysSelectAsActiveMesh = !0;
                let o = Math.max(1, i[n]),
                    s = {
                        mesh: r,
                        matrices: new Float32Array(o * 16),
                        settings: new Float32Array(o * 4),
                        count: i[n],
                        dirty: {
                            matrices: !1,
                            settings: !1
                        }
                    },
                    c = new Float32Array(o * 4);
                for (let e = 0; e < o; e++) {
                    let t = .82 + a() * .18;
                    c.set([t, t, t, 1], e * 4)
                }
                return r.thinInstanceSetBuffer(`matrix`, s.matrices, 16, !1), r.thinInstanceSetBuffer(`bakedVertexAnimationSettingsInstanced`, s.settings, 4, !1), r.thinInstanceSetBuffer(`color`, c, 4, !0), r.thinInstanceCount = i[n], r.setEnabled(i[n] > 0), s
            }), this.meshes = this.groups.map(e => e.mesh), this.dancers.forEach((e, t) => {
                this.writeMatrix(t), this.writeSettings(t)
            }), this.flush()
        }
        get count() {
            return this.dancers.length
        }
        setVisible(e) {
            this.visible = e;
            for (let t of this.groups) t.mesh.setEnabled(e && t.count > 0)
        }
        place(e) {
            let t = qn(2024),
                n = .6,
                r = [];
            for (let e = W.xMin + 1; e <= W.xMax - 1; e += n)
                for (let i = W.zMin + 2.5; i <= W.zMax - 1; i += n) {
                    let a = e + (t() - .5) * n * .7,
                        o = i + (t() - .5) * n * .7;
                    Bt(a, o, G, .9) || Ft.some(e => Math.abs(a - e.x) < e.w / 2 + .55 && Math.abs(o - e.z) < e.d / 2 + .55) || Pt.some(e => Math.hypot(a - e.x, o - e.z) < e.r + .7) || o < W.zMin + 3.5 && Math.abs(a) < 2.8 || r.push({
                        x: a,
                        z: o,
                        w: Math.hypot(a, o - 6) * .35 + Math.abs(a) * .15 + t() * 9
                    })
                }
            r.sort((e, t) => e.w - t.w);
            for (let n of r.slice(0, e)) {
                let e = it[Math.floor(t() * it.length)],
                    r = this.dancers.length;
                this.dancers.push({
                    x: n.x,
                    z: n.z,
                    yaw: Math.atan2(-n.x, (G.zMin + G.zMax) / 2 - n.z) + (t() - .5) * .9,
                    scale: .9 + t() * .18,
                    loop: e,
                    everyday: e,
                    half: (e === `nod` || e === `bounce` || e === `wave`) && t() < .3,
                    offsetBeats: Math.floor(t() * 4),
                    ox: 0,
                    oz: 0,
                    group: 0,
                    slot: 0
                }), this.grid.add(r, n.x, n.z)
            }
        }
        writeMatrix(e) {
            let t = this.dancers[e],
                n = this.groups[t.group],
                r = Math.cos(t.yaw) * t.scale,
                i = Math.sin(t.yaw) * t.scale;
            n.matrices.set([r, 0, -i, 0, 0, t.scale, 0, 0, i, 0, r, 0, t.x + t.ox, 0, t.z + t.oz, 1], t.slot * 16), n.dirty.matrices = !0
        }
        writeSettings(e) {
            let t = this.dancers[e],
                n = this.groups[t.group],
                [r, i] = this.ranges[t.loop];
            n.settings.set([r, i, t.offsetBeats * 12, t.half && !this.hype ? dr / 2 : dr], t.slot * 4), n.dirty.settings = !0
        }
        setHype(e) {
            if (e === this.hype) return;
            this.hype = e;
            let t = qn(e ? 5 : 6);
            this.dancers.forEach((n, r) => {
                n.loop = e ? t() < .72 ? `jump` : `cheer` : n.everyday, this.writeSettings(r)
            })
        }
        groove(e, t, n) {
            let r = Math.sin(n),
                i = Math.cos(n),
                a = n => {
                    let a = this.dancers[n],
                        o = a.x + a.ox - e,
                        s = a.z + a.oz - t,
                        c = Math.hypot(o, s);
                    return c > 2.6 ? 1 / 0 : c - .6 * (o * r + s * i) / Math.max(c, .001)
                },
                o = -1,
                s = 1 / 0;
            for (let n of this.grid.near(e, t)) {
                let e = a(n);
                e < s && (o = n, s = e)
            }
            if (this.leader >= 0 && a(this.leader) < s + .5 && (o = this.leader), this.leader = o, o < 0) return null;
            let c = this.dancers[o];
            return {
                loop: c.loop,
                offset: c.offsetBeats,
                half: c.half && !this.hype
            }
        }
        density(e, t) {
            let n = this.grid.near(e, t).filter(n => Math.hypot(this.dancers[n].x - e, this.dancers[n].z - t) < 1.1).length;
            return Math.min(1, n / 3)
        }
        update(e, t, n) {
            if (this.manager.time = 1e3 + e, this.visible) {
                if (t)
                    for (let e of this.grid.near(t.x, t.z)) this.active.add(e);
                for (let e of this.active) {
                    let r = this.dancers[e],
                        i = 0,
                        a = 0,
                        o = t ? Math.hypot(r.x - t.x, r.z - t.z) : 1 / 0;
                    if (t && o < Ar && o > 1e-4) {
                        let e = (Ar - o) * .95 / o;
                        i = (r.x - t.x) * e, a = (r.z - t.z) * e
                    }
                    r.ox = A(r.ox, i, 9, n), r.oz = A(r.oz, a, 9, n), Math.abs(r.ox) < .002 && Math.abs(r.oz) < .002 && o > 1.6 && (r.ox = r.oz = 0, this.active.delete(e)), this.writeMatrix(e)
                }
                this.flush()
            }
        }
        flush() {
            for (let e of this.groups) e.dirty.matrices && e.mesh.thinInstanceBufferUpdated(`matrix`), e.dirty.settings && e.mesh.thinInstanceBufferUpdated(`bakedVertexAnimationSettingsInstanced`), e.dirty.matrices = e.dirty.settings = !1
        }
    },
    Mr = [{
        name: `spruce`,
        height: 15,
        radius: 3.1,
        firstBranch: 1.6,
        whorls: 17,
        perWhorl: 7,
        trunk: .3,
        crown: 0
    }, {
        name: `fir`,
        height: 11,
        radius: 2.5,
        firstBranch: 1.1,
        whorls: 14,
        perWhorl: 6,
        trunk: .24,
        crown: .1
    }, {
        name: `pine`,
        height: 18,
        radius: 2.8,
        firstBranch: 8.5,
        whorls: 10,
        perWhorl: 6,
        trunk: .28,
        crown: .9
    }],
    Nr = {
        name: `snag`,
        height: 12,
        radius: 1.6,
        firstBranch: 2.5,
        whorls: 9,
        perWhorl: 3,
        trunk: .26,
        crown: 0,
        dead: !0
    },
    Pr = () => ({
        pos: [],
        nor: [],
        uv: [],
        col: [],
        idx: []
    });

function Fr(e, t, n) {
    let r = e.pos.length / 3,
        i = t.positions,
        a = t.normals;
    for (let r = 0; r < i.length / 3; r++) {
        e.pos.push(i[r * 3], i[r * 3 + 1], i[r * 3 + 2]), e.nor.push(a[r * 3], a[r * 3 + 1], a[r * 3 + 2]), e.uv.push(t.uvs[r * 2], t.uvs[r * 2 + 1]);
        let o = n(i[r * 3 + 1]);
        e.col.push(o, o, o, 1)
    }
    for (let n of t.indices) e.idx.push(n + r)
}

function Ir(e, t, r) {
    let i = new n;
    i.positions = r.pos, i.normals = r.nor, i.uvs = r.uv, i.colors = r.col, i.indices = r.idx;
    let a = new w(e, t);
    return i.applyToMesh(a), a.useVertexColors = !0, a
}

function Lr(e, t, n) {
    let r = 0,
        i = 0;
    for (let a = 0; a < 5; a++) {
        let o = a / 5 * n.height,
            s = (a + 1) / 5 * n.height,
            l = n.trunk * (1 - a / 5 * .85) * (a === 0 ? 1.35 : 1),
            u = n.trunk * (1 - (a + 1) / 5 * .85),
            d = r + (t() - .5) * .18,
            f = i + (t() - .5) * .18,
            p = _({
                height: s - o,
                diameterTop: u * 2,
                diameterBottom: l * 2,
                tessellation: 9,
                cap: 0
            }),
            m = s - o,
            h = c.FromValues(1, 0, 0, 0, (d - r) / m, 1, (f - i) / m, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        p.transform(c.Translation(0, m / 2, 0).multiply(h).multiply(c.Translation(r, o, i)));
        for (let e = 1; e < p.uvs.length; e += 2) p.uvs[e] = p.uvs[e] * m / 1.6 + o / 1.6;
        Fr(e, p, e => .55 + Math.min(1, e / 4) * .45), r = d, i = f
    }
}

function Rr(e, t, n, r, i) {
    let a = _({
            height: r,
            diameterTop: i * .3,
            diameterBottom: i * 2,
            tessellation: 5,
            cap: 0
        }),
        o = new T(0, 1, 0),
        s = T.Cross(o, n),
        l = Math.acos(Math.max(-1, Math.min(1, T.Dot(o, n)))),
        u = s.lengthSquared() > 1e-6 ? c.RotationAxis(s.normalize(), l) : c.Identity();
    a.transform(c.Translation(0, r / 2, 0).multiply(u).multiply(c.Translation(t.x, t.y, t.z))), Fr(e, a, () => .5)
}

function zr(e, t, n, r, i, a, o) {
    let s = new T(Math.cos(n) * Math.cos(i), -Math.sin(i), Math.sin(n) * Math.cos(i)),
        c = new T(-Math.sin(n), 0, Math.cos(n)),
        l = r * (.55 + o() * .2),
        u = new T(Math.cos(n), .55, Math.sin(n)).normalize();
    for (let i of [.5 + o() * .25, -.5 - o() * .25]) {
        let o = Math.cos(i),
            d = Math.sin(i),
            f = c.scale(o).add(T.Cross(s, c).scale(d)).scale(l / 2),
            p = new T(Math.cos(n) * .12, t, Math.sin(n) * .12),
            m = p.add(s.scale(r)),
            h = e.pos.length / 3;
        for (let [t, n, r] of [
                [p.subtract(f), 0, 0],
                [p.add(f), 0, 1],
                [m.subtract(f), 1, 0],
                [m.add(f), 1, 1]
            ]) {
            e.pos.push(t.x, t.y, t.z), e.nor.push(u.x, u.y, u.z), e.uv.push(n, r);
            let i = (.45 + n * .55) * a;
            e.col.push(i, i, i, 1)
        }
        e.idx.push(h, h + 2, h + 1, h + 1, h + 2, h + 3)
    }
}

function Br(e, t, n, r) {
    let i = qn(n),
        a = Pr(),
        o = Pr();
    Lr(a, i, t);
    let s = Math.round(t.firstBranch * 2.2);
    for (let e = 0; e < s; e++) {
        let e = .9 + i() * Math.max(.3, t.firstBranch - 1),
            n = i() * Math.PI * 2,
            r = new T(Math.cos(n), -.15 - i() * .3, Math.sin(n)).normalize();
        Rr(a, new T(0, e, 0), r, .4 + i() * .8, .03)
    }
    let c = t.height - t.firstBranch;
    for (let e = 0; e < t.whorls; e++) {
        let n = e / (t.whorls - 1),
            r = t.firstBranch + n * c * .97,
            s = (1 - n) ** .95,
            l = Math.sin(Math.min(1, n * 1.15) * Math.PI) * .9 + .15,
            u = t.radius * ((1 - t.crown) * s + t.crown * l) * (.85 + i() * .3) + .25,
            d = Math.max(3, Math.round(t.perWhorl * (.6 + .4 * (1 - n)))),
            f = i() * Math.PI * 2,
            p = .55 + .45 * n;
        for (let e = 0; e < d; e++) {
            let s = f + e / d * Math.PI * 2 + (i() - .5) * .5,
                c = u * (.8 + i() * .35);
            if (t.dead) {
                let e = new T(Math.cos(s), -.1 - i() * .35, Math.sin(s)).normalize();
                Rr(a, new T(0, r, 0), e, c * .8, .035 * (1 - n * .6))
            } else zr(o, r, s, c, .12 + (1 - n) * .32 + i() * .1, p, i)
        }
    }
    t.dead || zr(o, t.height * .97, i() * 6.28, .9, -1.2, 1, i);
    let l = Ir(`${t.name}-bark`, e, a);
    l.material = r.bark;
    let u = null;
    return o.pos.length && (u = Ir(`${t.name}-needles`, e, o), u.material = r.needles), {
        bark: l,
        needles: u
    }
}

function Vr(e, t) {
    return {
        bark: Z(e, `tree-bark-mat`, {
            texture: t.bark,
            color: X(.9, .82, .74),
            specular: .02,
            lights: 6
        }),
        needles: Z(e, `tree-needle-mat`, {
            texture: t.branch,
            alphaCutOff: .45,
            color: X(.9, 1.05, .95),
            specular: X(.03, .04, .03),
            emissive: X(.006, .012, .01),
            sides: `lit`,
            lights: 6
        })
    }
}

function Hr(e, t, n) {
    let r = qn(n),
        i = Pr(),
        a = _({
            height: 1,
            diameterTop: .8,
            diameterBottom: 1,
            tessellation: 10
        });
    a.transform(c.RotationZ(Math.PI / 2));
    for (let e = 1; e < a.uvs.length; e += 2) a.uvs[e] *= 3;
    Fr(i, a, e => .6 + (e + .5) * .5);
    for (let e = 0; e < 4; e++) {
        let e = (r() - .5) * .8,
            t = r() * Math.PI * 2;
        Rr(i, new T(e, 0, 0), new T(.2, Math.cos(t), Math.sin(t)).normalize(), .5 + r() * .4, .05)
    }
    let o = Ir(`log`, e, i);
    return o.material = t, o
}

function Ur(e, t, r) {
    let i = qn(r),
        a = ne({
            diameter: 1,
            segments: 7
        }),
        o = a.positions,
        s = Array.from({
            length: 6
        }, () => [i() * 2 - 1, i() * 2 - 1, i() * 2 - 1, .1 + i() * .18]);
    for (let e = 0; e < o.length; e += 3) {
        let t = o[e],
            n = o[e + 1],
            r = o[e + 2],
            i = 1;
        for (let [e, a, o, c] of s) i += Math.max(0, t * e + n * a + r * o) * c;
        o[e] = t * i, o[e + 1] = n * i * .72, o[e + 2] = r * i
    }
    n.ComputeNormals(o, a.indices, a.normals);
    let c = Pr(),
        l = [];
    Fr(c, a, () => 1);
    for (let e = 0; e < c.nor.length / 3; e++) {
        let t = Math.max(0, c.nor[e * 3 + 1]);
        l.push(1 - t * .45, 1 - t * .1, 1 - t * .5, 1)
    }
    c.col = l;
    let u = Ir(`boulder-${r}`, e, c);
    return u.material = t, u
}
var Wr = -144,
    Gr = 45,
    Kr = 1.25,
    qr = 1.05;

function Jr(e, t) {
    let n = new Map;
    for (let e = 0; e < t.length; e += 16) {
        let r = `${Math.floor(t[e+12]/24)},${Math.floor(t[e+14]/24)}`,
            i = n.get(r),
            a = t.slice(e, e + 16);
        i ? i.push(...a) : n.set(r, a)
    }
    let r = [...n.values()],
        i = r.map((t, n) => {
            if (n === 0) return e;
            let r = e.clone(`${e.name}-chunk-${n}`);
            return r.makeGeometryUnique(), r
        });
    return r.forEach((e, t) => {
        i[t].thinInstanceSetBuffer(`matrix`, new Float32Array(e), 16, !0), i[t].thinInstanceRefreshBoundingInfo(!1)
    }), i.length || e.setEnabled(!1), i
}
var Yr = class extends Cr {
    moonDir = new T(.45, -.42, -.79).normalize();
    moon;
    sky;
    mouthLight;
    headlights;
    colliders = new kr(4);
    chunks = [];
    cullTick = 0;
    wasEnabled = !0;
    constructor(e, t, n) {
        super();
        let r = qn(31337);
        this.moon = new re(`moon`, this.moonDir.clone(), e), this.moon.diffuse = Qt.clone(), this.moon.specular = Qt.scale(.58), this.moon.intensity = Kr, this.sky = er(e, `forest-sky`, $t, en, qr), this.lights.push(this.moon, this.sky);
        let i = Z(e, `forest-ground-mat`, {
                texture: t.floor,
                specular: .03,
                color: X(1.35, 1.4, 1.45),
                lights: 6
            }),
            a = (t, n, r, a, o) => {
                let s = r - n,
                    c = y(t, {
                        width: 176,
                        height: s,
                        subdivisionsX: 110,
                        subdivisionsY: a
                    }, e);
                c.position.set(0, 0, (n + r) / 2), Zn(c, e => {
                    for (let t = 0; t < e.length; t += 3) e[t + 1] = o(e[t], e[t + 2] + c.position.z)
                }), Xn(c, 36, s / 5), c.material = i, this.meshes.push(c)
            };
        a(`forest-ground`, -203, -79.2, 100, Ut), a(`embankment`, -79.15, 32, 60, Gt);
        let o = Yn(`trail`, e, q, 2.6, .015);
        o.material = Z(e, `trail-mat`, {
            texture: t.floor,
            color: X(1.8, 1.55, 1.3),
            specular: .02,
            zOffset: -2
        }), this.meshes.push(o);
        let s = (e, t) => Ut(e, t),
            l = (e, t, n, i, a, o = 0, s = i) => {
                let l = p.RotationAxis(T.Up(), a),
                    u = o ? p.RotationAxis(new T(r() - .5, 0, r() - .5).normalize(), o) : p.Identity();
                return c.Compose(new T(i, s, i), u.multiply(l), new T(e, t, n)).m
            },
            u = Vr(e, t);
        bn(u.bark, .3, 16), bn(u.needles, .3, 16);
        let d = [...Mr, Nr].map((t, n) => ({
                sp: t,
                meshes: Br(e, t, 101 + n * 37, u),
                m: []
            })),
            f = () => {
                let e = r();
                return e < .42 ? d[0] : e < .72 ? d[1] : e < .95 ? d[2] : d[3]
            },
            m = (e, t) => t > -96 && Math.abs(e) < 17 || t > -94 && Wt(e, t) < 3.5 || Math.hypot(e - J.x, t - J.z) < 7 || Math.abs(t - Wr) < 1.2,
            h = Math.round(300 + 220 * Math.min(1, n.grass)),
            g = 0,
            _ = 0,
            b = [];
        for (; _ < h && g++ < h * 30;) {
            let e = H.xMin + r() * (H.xMax - H.xMin),
                t = H.zMin + r() * (-79.8 - H.zMin);
            if (Xt(e, t) < 4.4 + r() * 2.5 || m(e, t) || b.some(([n, r]) => (n - e) ** 2 + (r - t) ** 2 < 6.5)) continue;
            b.push([e, t]);
            let n = f(),
                i = .75 + r() * .55;
            n.m.push(...l(e, s(e, t) - .1, t, i, r() * Math.PI * 2, (r() - .5) * .05, i * (.9 + r() * .25))), this.addCollider({
                x: e,
                z: t,
                r: n.sp.trunk * 1.2 * i + .05
            }), _++
        }
        for (let e = 0; e < 260 * Math.min(1.2, n.grass + .3); e++) {
            let e = H.xMin + r() * (H.xMax - H.xMin),
                t = H.zMin + r() * (-82 - H.zMin);
            if (Xt(e, t) < 2.6 || m(e, t)) continue;
            let n = .12 + r() ** 1.5 * .28;
            d[1].m.push(...l(e, s(e, t) - .05, t, n, r() * Math.PI * 2, (r() - .5) * .12))
        }
        let ee = Math.round(150 * Math.min(1, .4 + n.grass * .6));
        for (let e = 0; e < ee; e++) {
            let e = (r() < .5 ? -1 : 1) * (H.xMax + 2 + r() * 34),
                t = H.zMin - 14 + r() * (-78 - H.zMin + 8);
            d[r() < .6 ? 0 : 2].m.push(...l(e, s(e, t) - .2, t, 1.1 + r() * .5, r() * 6.28))
        }
        for (let e = 0; e < 70; e++) {
            let e = -60 + r() * 120,
                t = -76.8 + r() * 56;
            t < -74 && Math.abs(e) < 5 || d[r() < .5 ? 0 : r() < .6 ? 1 : 2].m.push(...l(e, Gt(e, t) - .15, t, .8 + r() * .5, r() * 6.28))
        }
        for (let e = 0; e < ee * .6; e++) {
            let e = -80 + r() * 160,
                t = H.zMin - 6 - r() * 32;
            d[r() < .6 ? 0 : 1].m.push(...l(e, s(e, t) - .2, t, 1.1 + r() * .5, r() * 6.28))
        }
        for (let e of d)
            for (let t of [e.meshes.bark, e.meshes.needles]) t && this.chunks.push(...Jr(t, e.m));
        let te = Z(e, `rock-mat`, {
                texture: t.concrete,
                color: X(.5, .52, .5),
                specular: X(.05, .05, .06),
                lights: 6
            }),
            ne = [0, 1, 2].map(t => Ur(e, te, 900 + t)),
            ie = [
                [],
                [],
                []
            ],
            S = (e, t, n) => {
                ie[Math.floor(r() * 3)].push(...l(e, s(e, t) + n * .05, t, n, r() * 6.28, 0, n * (.7 + r() * .5))), this.addCollider({
                    x: e,
                    z: t,
                    r: n * .5
                })
            };
        for (let e = 0; e < 80; e++) {
            let e = H.xMin + r() * (H.xMax - H.xMin),
                t = H.zMin + r() * (-82 - H.zMin);
            Xt(e, t) < 2.4 || m(e, t) || S(e, t, .35 + r() ** 2 * 1.6)
        }
        S(17.8, -121.6, 2.3), S(15.8, -122.5, 1.4), S(17, -119.6, 1.1), ne.forEach((e, t) => {
            e.thinInstanceSetBuffer(`matrix`, new Float32Array(ie[t].length ? ie[t] : c.Translation(0, -50, 0).m), 16, !0), this.meshes.push(e)
        });
        let ae = Z(e, `log-mat`, {
                texture: t.bark,
                color: X(.7, .72, .6),
                specular: Zt,
                lights: 6
            }),
            se = Hr(e, ae, 77),
            ue = [],
            de = [
                [-6.5, -147, .3, 6],
                [7.5, -137, -.9, 5],
                [-11, -120, 1.2, 7],
                [9.5, -110, .2, 6],
                [-9, -98, -.5, 5.5],
                [14, -150, .8, 7],
                [-20, -132, .1, 8],
                [22, -104, 1.5, 6]
            ];
        for (let [e, t, n, i] of de) {
            let a = .4 + r() * .3,
                o = s(e, t) + a * .35;
            ue.push(...c.Compose(new T(i, a, a), p.RotationAxis(T.Up(), n), new T(e, o, t)).m);
            for (let r = -.45; r <= .45; r += .15) this.addCollider({
                x: e + Math.cos(n) * i * r,
                z: t - Math.sin(n) * i * r,
                r: a * .55
            })
        }
        se.thinInstanceSetBuffer(`matrix`, new Float32Array(ue), 16, !0), this.meshes.push(se);
        let fe = [
            [-14, -146],
            [6, -142],
            [-8, -126],
            [11, -118],
            [-5, -108]
        ];
        for (let [t, n] of fe) {
            let i = x(`stump`, {
                height: .6,
                diameterTop: .85,
                diameterBottom: 1.15,
                tessellation: 11
            }, e);
            i.position.set(t, s(t, n) + .28, n), i.rotation.y = r() * 6, i.material = ae, this.addCollider({
                x: t,
                z: n,
                r: .5
            }), this.meshes.push(i)
        }
        let me = Z(e, `fern-mat`, {
            texture: t.fern,
            specular: Zt,
            sides: `lit`,
            color: X(.95, 1.1, .9),
            lights: 6
        });
        bn(me, .06, 1);
        let ge = [];
        for (let t = 0; t < 6; t++) {
            let n = v(`frond`, {
                width: .45,
                height: .9
            }, e);
            n.bakeTransformIntoVertices(c.Translation(0, .45, 0).multiply(c.RotationX(-.75 - t % 2 * .2)).multiply(c.RotationY(t / 6 * Math.PI * 2))), ge.push(n)
        }
        let _e = w.MergeMeshes(ge, !0);
        _e.name = `ferns`, _e.material = me;
        let E = [];
        for (let e = 0; e < 900 * Math.min(1.3, n.grass + .2); e++) {
            let e = H.xMin + r() * (H.xMax - H.xMin),
                t = H.zMin + r() * (-81 - H.zMin),
                n = Xt(e, t);
            n < 1.9 || n > 9 && r() < .45 || m(e, t) || E.push(...l(e, s(e, t), t, .6 + r() * .9, r() * 6.28))
        }
        this.chunks.push(...Jr(_e, E));
        let D = Z(e, `grass-mat`, {
            texture: t.grass,
            specular: Zt,
            sides: `lit`,
            color: X(1.45, 1.7, 1.35),
            emissive: X(.015, .025, .02),
            lights: 6
        });
        bn(D, .07, .8);
        let ve = [];
        for (let t = 0; t < 3; t++) {
            let n = v(`grass-card`, {
                width: 1,
                height: .65
            }, e);
            n.bakeTransformIntoVertices(c.Translation(0, .32, 0).multiply(c.RotationY(t / 3 * Math.PI))), ve.push(n)
        }
        let O = w.MergeMeshes(ve, !0);
        O.name = `grass`, O.material = D;
        let k = [],
            ye = Math.round(2600 * n.grass);
        for (let e = 0; e < ye; e++) {
            let e = r(),
                t = Math.floor(e * (q.length - 1)),
                n = e * (q.length - 1) - t,
                [i, a] = q[t],
                [o, c] = q[t + 1],
                u = r() < .5 ? -1 : 1,
                d = 1.5 + r() ** 1.8 * 10,
                f = i + (o - i) * n + u * d + (r() - .5) * 2,
                p = a + (c - a) * n + (r() - .5) * 4;
            if (p > -79) continue;
            let m = (.4 + r() * .6) * (d < 3 ? .65 : 1);
            k.push(...l(f, s(f, p), p, m, r() * 6, 0, m * (.8 + r() * .6)))
        }
        this.chunks.push(...Jr(O, k));
        let be = oe(`cap`, {
            diameter: .12,
            segments: 5,
            slice: .5
        }, e);
        be.bakeTransformIntoVertices(c.Scaling(1, .6, 1).multiply(c.Translation(0, .07, 0)));
        let A = x(`stem`, {
            height: .08,
            diameter: .025,
            tessellation: 5
        }, e);
        A.bakeTransformIntoVertices(c.Translation(0, .04, 0));
        let xe = w.MergeMeshes([be, A], !0);
        xe.name = `mushrooms`, xe.material = Z(e, `mushroom-mat`, {
            color: X(.82, .78, .7),
            specular: .1,
            lights: 6
        });
        let j = [];
        for (let [e, t] of [...fe, ...de.map(([e, t]) => [e, t])]) {
            let n = 4 + Math.floor(r() * 7);
            for (let i = 0; i < n; i++) {
                let n = r() * Math.PI * 2,
                    i = .5 + r() * .6,
                    a = e + Math.cos(n) * i,
                    o = t + Math.sin(n) * i;
                j.push(...l(a, s(a, o), o, .6 + r() * .9, r() * 6, (r() - .5) * .3))
            }
        }
        xe.thinInstanceSetBuffer(`matrix`, new Float32Array(j), 16, !0), this.meshes.push(xe);
        let Se = Z(e, `fence-mat`, {
                texture: t.chainLink,
                specular: X(.3, .3, .32),
                sides: `lit`,
                lights: 6
            }),
            Ce = 0;
        for (let e = 0; e < q.length - 1; e++) {
            let [t, n] = q[e], [r, i] = q[e + 1];
            (n - Wr) * (i - Wr) <= 0 && n !== i && (Ce = t + (Wr - n) / (i - n) * (r - t))
        }
        let we = 2.2,
            Te = [];
        for (let e = Ce - 1.5; e >= H.xMin; e -= 3) Te.unshift(e);
        for (let e = Ce + 1.5; e <= H.xMax; e += 3) Te.push(e);
        for (let t = 0; t < Te.length - 1; t++) {
            let n = Te[t],
                r = Te[t + 1],
                i = s(n, Wr),
                a = s(r, Wr);
            if (n < Ce && r > Ce) {
                let t = v(`fence-flap`, {
                    width: 1.4,
                    height: we * .92
                }, e);
                Xn(t, 1.4 / .55, we * .92 / .55), t.position.set(r - .45, a + we * .46 + .05, -144.6), t.rotation.set(.1, -1.15, .22), t.material = Se, this.meshes.push(t);
                continue
            }
            let o = v(`fence-pane`, {
                width: r - n,
                height: we
            }, e);
            o.position.set((n + r) / 2, (i + a) / 2 + we / 2 + .05, Wr), o.rotation.z = Math.atan2(a - i, r - n), Xn(o, (r - n) / .55, we / .55), o.material = Se, this.meshes.push(o);
            for (let e = 0; e <= 1.001; e += .2) this.addCollider({
                x: n + (r - n) * e,
                z: Wr,
                r: .3
            })
        }
        let Ee = x(`fence-post`, {
            height: 2.5,
            diameter: .07,
            tessellation: 7
        }, e);
        Ee.bakeTransformIntoVertices(c.Translation(0, 2.5 / 2, 0)), Ee.material = Z(e, `fence-post-mat`, {
            color: X(.36, .36, .37),
            specular: X(.4, .4, .42),
            lights: 6
        });
        let De = [];
        for (let e of Te) De.push(...c.Compose(new T(1, 1, 1), p.RotationAxis(new T(0, 0, 1), (r() - .5) * .05), new T(e, s(e, Wr), Wr)).m);
        Ee.thinInstanceSetBuffer(`matrix`, new Float32Array(De), 16, !0), this.meshes.push(Ee);
        let Oe = new pe(`no-trespassing`, {
            width: 512,
            height: 320
        }, e, !0);
        {
            let e = Oe.getContext();
            e.fillStyle = `#d9d6cc`, e.fillRect(0, 0, 512, 320), e.fillStyle = `#a3261f`, e.fillRect(0, 0, 512, 92), e.fillStyle = `#f2efe6`, e.font = `800 60px "Arial Black", sans-serif`, e.textAlign = `center`, e.textBaseline = `middle`, e.fillText(`DANGER`, 256, 48), e.fillStyle = `#1c1c1c`, e.font = `800 48px "Arial Black", sans-serif`, e.fillText(`NO TRESPASSING`, 256, 160), e.font = `700 30px "Arial", sans-serif`, e.fillText(`STORM DRAIN · KEEP OUT`, 256, 232);
            for (let t = 0; t < 90; t++) e.fillStyle = `rgba(${90+Math.random()*60},${50+Math.random()*30},20,${.08+Math.random()*.2})`, e.fillRect(Math.random() * 512, Math.random() * 320, 2 + Math.random() * 4, 10 + Math.random() * 70);
            Oe.update()
        }
        let M = v(`no-trespassing`, {
            width: .9,
            height: .56
        }, e);
        M.position.set(Ce - 2.4, s(Ce - 2.4, Wr) + 1.35, -144.04), M.rotation.z = .06, M.material = Z(e, `no-trespassing-mat`, {
            texture: Oe,
            specular: .12,
            sides: `both`,
            lights: 6
        }), this.meshes.push(M);
        let ke = Z(e, `car-mat`, {
                color: X(.08, .09, .11),
                specular: X(.6, .65, .8),
                gloss: 96
            }),
            Ae = new w(`car`, e),
            je = C(`car-body`, {
                width: 1.9,
                height: .75,
                depth: 4.5
            }, e);
        je.position.y = .62;
        let Me = C(`car-cabin`, {
            width: 1.7,
            height: .62,
            depth: 2.3
        }, e);
        Me.position.set(0, 1.28, -.25);
        for (let e of [je, Me]) e.material = ke, e.parent = Ae;
        let Ne = Z(e, `tyre-mat`, {
            color: X(.02, .02, .02),
            specular: .05
        });
        for (let [t, n] of [
                [-.9, 1.4],
                [.9, 1.4],
                [-.9, -1.4],
                [.9, -1.4]
            ]) {
            let r = x(`tyre`, {
                height: .28,
                diameter: .68,
                tessellation: 14
            }, e);
            r.rotation.z = Math.PI / 2, r.position.set(t, .34, n), r.material = Ne, r.parent = Ae
        }
        let Pe = Z(e, `headlamp-mat`, {
                unlit: !0,
                emissive: X(1, .95, .8)
            }),
            Fe = Z(e, `taillamp-mat`, {
                unlit: !0,
                emissive: nn
            });
        for (let t of [-.65, .65]) {
            let n = he(`headlamp`, {
                radius: .13,
                tessellation: 12
            }, e);
            n.position.set(t, .7, 2.26), n.rotation.y = Math.PI, n.material = Pe, n.parent = Ae;
            let r = C(`taillamp`, {
                width: .35,
                height: .1,
                depth: .02
            }, e);
            r.position.set(t, .8, -2.26), r.material = Fe, r.parent = Ae
        }
        Ae.position.set(J.x, 0, J.z), Ae.rotation.y = J.yaw, this.addCollider({
            x: J.x,
            z: J.z,
            r: 1.5
        }), this.addCollider({
            x: J.x + .8,
            z: J.z + 1.8,
            r: 1.2
        }), this.addCollider({
            x: J.x - .8,
            z: J.z - 1.8,
            r: 1.2
        }), this.meshes.push(Ae), this.headlights = new le(`headlights`, new T(J.x + Math.sin(J.yaw) * 2.4, .75, J.z + Math.cos(J.yaw) * 2.4), new T(Math.sin(J.yaw), -.08, Math.cos(J.yaw)), Math.PI / 3.2, 6, e), this.headlights.diffuse = tn.clone(), this.headlights.specular = tn.scale(.6), this.headlights.intensity = 2.2, this.headlights.range = 40, this.lights.push(this.headlights);
        let Ie = Z(e, `culvert-mat`, {
                texture: t.concrete,
                bump: t.concreteBump,
                color: X(.62, .62, .64),
                specular: X(.08, .08, .09),
                sides: `lit`,
                lights: 6
            }),
            Le = Jn(`headwall`, e, {
                x0: -20,
                x1: 20,
                y0: -.8,
                y1: 7.2,
                cx: 0,
                cy: U.centerY,
                r: U.radius,
                depth: 1.2
            });
        Le.position.z = -79.2, Le.material = Ie, this.meshes.push(Le);
        for (let t of [-1, 1]) {
            let n = C(`wingwall`, {
                width: Y.thick,
                height: Y.top,
                depth: Y.length
            }, e);
            Zn(n, e => {
                for (let t = 0; t < e.length; t += 3) e[t + 1] > 0 && (e[t + 1] = -Y.top / 2 + Y.foot + (Y.top - Y.foot) * ((e[t + 2] + Y.length / 2) / Y.length))
            });
            let r = -t * Y.yaw,
                i = Y.length / 2 * Math.cos(Y.yaw) - .2,
                a = t * (Y.x + Y.thick / 2 / Math.cos(Y.yaw) + i * Math.tan(Y.yaw)),
                o = -79.2 - i;
            n.position.set(a, Y.top / 2, o), n.rotation.y = r;
            for (let e = -4; e <= 4; e += 1) this.addCollider({
                x: a + Math.sin(r) * e,
                z: o + Math.cos(r) * e,
                r: .55
            });
            n.material = Ie, this.meshes.push(n)
        }
        let N = C(`apron`, {
            width: 7.2,
            height: .4,
            depth: 4.4
        }, e);
        N.position.set(0, -.18, -80.1), N.material = Ie, Xn(N, 2, 1.2), this.meshes.push(N);
        let Re = Z(e, `collar-mat`, {
                texture: t.concrete,
                color: X(.48, .48, .5),
                specular: X(.08, .08, .09)
            }),
            P = ce(`collar`, {
                diameter: U.radius * 2 + .5,
                thickness: .55,
                tessellation: 64
            }, e);
        P.rotation.x = Math.PI / 2, P.position.set(0, U.centerY, -79.25), P.material = Re, this.meshes.push(P);
        let ze = Z(e, `rebar-mat`, {
            color: X(.16, .08, .05),
            specular: X(.2, .15, .1)
        });
        for (let t = -3; t <= 3; t++) {
            let n = x(`bar`, {
                    height: 2.6,
                    diameter: .07,
                    tessellation: 6
                }, e),
                i = t * .85,
                a = U.centerY + Math.sqrt(Math.max(0, U.radius * U.radius - i * i));
            n.position.set(i, a - 1.1, -79.3), n.rotation.z = (r() - .5) * .4 + (Math.abs(t) === 1 ? .9 * Math.sign(t) : 0), n.rotation.x = -.25, n.material = ze, this.meshes.push(n)
        }
        for (let t = 0; t < 6; t++) {
            let n = x(`rung`, {
                height: .5,
                diameter: .04,
                tessellation: 6
            }, e);
            n.rotation.z = Math.PI / 2, n.position.set(5.6, .4 + t * .42, -79.32), n.material = ze, this.meshes.push(n)
        }
        let Be = Z(e, `junk-concrete-mat`, {
                texture: t.concrete,
                color: X(.55, .55, .57),
                specular: X(.05, .05, .06),
                lights: 6
            }),
            Ve = C(`rubble`, {
                size: 1
            }, e);
        Ve.material = Be;
        let He = [],
            F = (e, t, n, i) => {
                for (let a = 0; a < n; a++) {
                    let n = e + (r() - .5) * i,
                        a = t + (r() - .5) * i,
                        o = .25 + r() * .7,
                        l = p.FromEulerAngles((r() - .5) * .9, r() * 6.28, (r() - .5) * .9);
                    He.push(...c.Compose(new T(o * (1 + r()), o * (.4 + r() * .5), o * (.8 + r() * .6)), l, new T(n, s(n, a) + o * .15, a)).m), o > .6 && this.addCollider({
                        x: n,
                        z: a,
                        r: o * .6
                    })
                }
            };
        F(-9.5, -83, 14, 3.5), F(8.8, -85.5, 9, 2.6), F(-4.5, -91, 5, 2), Ve.thinInstanceSetBuffer(`matrix`, new Float32Array(He), 16, !0), this.meshes.push(Ve);
        let Ue = C(`barrier`, {
            width: 3.2,
            height: .8,
            depth: .6
        }, e);
        Ue.position.set(6.5, .28, -90.5), Ue.rotation.set(0, .6, 1.25), Ue.material = Be;
        for (let e = -1.4; e <= 1.4; e += .7) this.addCollider({
            x: 6.5 + Math.cos(.6) * e,
            z: -90.5 - Math.sin(.6) * e,
            r: .45
        });
        this.meshes.push(Ue);
        let We = Z(e, `drum-mat`, {
            texture: t.bark,
            color: X(.75, .42, .22),
            specular: X(.2, .14, .1),
            lights: 6
        });
        for (let [t, n, r, i] of [
                [-6.8, -81.4, 0, 0],
                [-6.1, -82.3, 0, .4],
                [10.8, -82.6, 1, 1.1]
            ]) {
            let a = x(`drum`, {
                height: .9,
                diameter: .6,
                tessellation: 14
            }, e);
            a.position.set(t, r ? .3 : .45, n), a.rotation.set(r ? Math.PI / 2 : 0, i, 0), a.material = We, this.addCollider({
                x: t,
                z: n,
                r: .45
            }), this.meshes.push(a)
        }
        let Ge = Z(e, `dump-tyre-mat`, {
            color: X(.04, .04, .045),
            specular: .08,
            lights: 6
        });
        for (let t = 0; t < 5; t++) {
            let n = ce(`dumped-tyre`, {
                diameter: .62,
                thickness: .22,
                tessellation: 16
            }, e);
            n.position.set(-11.5 + t % 2 * .35, .11 + Math.floor(t / 2) * .2, -89 + t % 3 * .2), n.rotation.set((r() - .5) * .3, r() * 3, (r() - .5) * .3), n.material = Ge, this.meshes.push(n)
        }
        this.addCollider({
            x: -11.3,
            z: -88.8,
            r: .6
        });
        let Ke = Z(e, `pallet-mat`, {
            texture: t.bark,
            color: X(.8, .72, .6),
            specular: Zt,
            lights: 6
        });
        for (let t = 0; t < 5; t++) {
            let n = C(`pallet-slat`, {
                width: 1.2,
                height: .1,
                depth: .025
            }, e);
            n.position.set(8.6, .25 + t * .24, -79.45), n.rotation.set(.25, 0, (r() - .5) * .08), n.material = Ke, this.meshes.push(n)
        }
        let qe = Z(e, `puddle-mat`, {
            color: X(.02, .025, .03),
            specular: X(.8, .85, .95),
            gloss: 200,
            bump: t.ripple,
            lights: 6
        });
        for (let [t, n, r] of [
                [-1.2, -83.6, 1.4],
                [1.6, -85.2, .9],
                [-2.6, -87.5, .7]
            ]) {
            let i = he(`puddle`, {
                radius: r,
                tessellation: 20
            }, e);
            i.rotation.x = Math.PI / 2, i.scaling.y = .65, i.position.set(t, .02, n), i.material = qe, this.meshes.push(i)
        }
        this.mouthLight = $n(e, `mouth-light`, new T(0, 2.2, -76), on, {
            intensity: 1.2,
            range: 28,
            shine: .55
        }), this.lights.push(this.mouthLight), this.meshes.splice(0, this.meshes.length, ...Qn(this.meshes));
        for (let e of this.lights) e.includedOnlyMeshes = [...this.meshes, ...this.chunks, ...Ae.getChildMeshes()]
    }
    near(e, t) {
        return this.colliders.near(e, t)
    }
    addCollider(e) {
        this.colliders.add(e, e.x, e.z, e.r)
    }
    update(e, t, n) {
        for (let t of this.lights) wr(t, n && (t !== this.headlights || e.z < -120));
        if (this.cullTick++ % 10 == 0 || n !== this.wasEnabled) {
            this.wasEnabled = n;
            for (let t of this.chunks) {
                let r = t.getBoundingInfo().boundingSphere;
                t.setEnabled(n && T.Distance(r.centerWorld, e) - r.radiusWorld < Gr)
            }
        }
        if (!n) return;
        let r = 1 - k(U.zStart - 1, U.zStart + 6, e.z);
        this.moon.intensity = Kr * r, this.sky.intensity = qr * r, this.mouthLight.intensity = (.5 + t * 1.1) * (1 - k(U.zStart + 10, U.zStart + 20, e.z))
    }
};
s.ShadersStore.aftersBeamVertexShader = `
precision highp float;
attribute vec3 position;
attribute vec3 normal;
uniform mat4 world;
uniform mat4 viewProjection;
uniform float len;
varying vec3 vPosW;
varying vec3 vNormalW;
varying float vT;
void main() {
  vec4 p = world * vec4(position, 1.0);
  vPosW = p.xyz;
  vNormalW = normalize(mat3(world) * normal);
  vT = -position.y / len;
  gl_Position = viewProjection * p;
}`, s.ShadersStore.aftersBeamFragmentShader = `
precision highp float;
varying vec3 vPosW;
varying vec3 vNormalW;
varying float vT;
uniform vec3 cameraPosition;
uniform vec3 color;
uniform float intensity;
uniform float time;
${tr}
void main() {
  float t = clamp(vT, 0.0, 1.0);
  float fall = pow(1.0 - t, 1.1) * smoothstep(0.0, 0.05, t);
  float core = pow(abs(dot(normalize(vNormalW), normalize(cameraPosition - vPosW))), 1.8);
  float haze = 0.45 + 0.55 * noise3(vPosW * 0.9 + vec3(time * 0.12, -time * 0.25, time * 0.07));
  gl_FragColor = vec4(color * intensity * fall * core * haze * 0.5, 1.0);
}`;
var Xr = [
        [-7.5, -8],
        [6.5, -5.5],
        [-8.5, 4.5],
        [8.5, 8],
        [-4.5, 12.5],
        [5.5, 13],
        [0, -13]
    ],
    Zr = 5.3,
    Qr = matchMedia(`(prefers-reduced-motion: reduce)`),
    $r = class {
        meshes = [];
        lamps = [];
        t = 0;
        level = 0;
        shown = !0;
        constructor(e) {
            let t = Z(e, `cable-mat`, {
                    color: X(.03, .03, .03),
                    specular: Zt
                }),
                n = Z(e, `lamp-cage-mat`, {
                    color: X(.06, .06, .07),
                    specular: X(.3, .3, .32)
                });
            n.wireframe = !0;
            let r = W.height - .1 - Zr,
                i = 5.5;
            Xr.forEach(([a, o], s) => {
                let l = new m(`lamp-pivot-${s}`, e);
                l.position.set(a, W.height - .1, o);
                let u = x(`lamp-cable-${s}`, {
                    height: r,
                    diameter: .02,
                    tessellation: 4
                }, e);
                u.position.y = -r / 2, u.material = t;
                let d = Z(e, `lamp-bulb-${s}`, {
                        unlit: !0,
                        emissive: sn.clone()
                    }),
                    f = oe(`lamp-bulb-${s}`, {
                        diameter: .16,
                        segments: 8
                    }, e);
                f.position.y = -r, f.material = d;
                let p = x(`lamp-cage-${s}`, {
                    height: .3,
                    diameterTop: .12,
                    diameterBottom: .34,
                    tessellation: 8,
                    cap: w.NO_CAP
                }, e);
                p.position.y = -r + .02, p.material = n;
                let h = nr(e, `lamp-beam-mat-${s}`, `aftersBeam`, `add`, [`position`, `normal`], [`world`, `viewProjection`, `len`, `cameraPosition`, `color`, `intensity`, `time`]);
                h.setFloat(`len`, i);
                let g = x(`lamp-beam-${s}`, {
                    height: i,
                    diameterTop: .18,
                    diameterBottom: 2.4,
                    tessellation: 24,
                    cap: w.NO_CAP
                }, e);
                g.bakeTransformIntoVertices(c.Translation(0, -5.5 / 2, 0)), g.position.y = -r, g.material = h, g.alwaysSelectAsActiveMesh = !0;
                for (let e of [u, f, p, g]) e.parent = l;
                this.meshes.push(u, f, p, g), this.lamps.push({
                    pivot: l,
                    beam: h,
                    bulb: d,
                    phase: s * 1.7,
                    faulty: s === 3,
                    sway: 0
                })
            })
        }
        update(e, t) {
            if (this.t += e, this.level = A(this.level, t.level, 2.5, e), t.visible !== this.shown) {
                this.shown = t.visible;
                for (let e of this.meshes) e.setEnabled(t.visible)
            }
            if (!t.visible) return;
            let n = Te(t.beat),
                r = this.level > .85,
                i = sn.scale(.85).add(t.tint.scale(.15)),
                a = k(.12, .9, t.reveal);
            for (let o of this.lamps) {
                o.sway = A(o.sway, t.bass * .05 + n * .02 * (r ? 3 : 1), 3, e), o.pivot.rotation.x = Math.sin(this.t * 1.3 + o.phase) * (.02 + o.sway), o.pivot.rotation.z = Math.cos(this.t * 1.1 + o.phase * 1.3) * (.02 + o.sway);
                let s = .55 + t.bass * .35;
                if (o.faulty && Math.sin(this.t * 19.3 + o.phase) * Math.sin(this.t * 5.1) + Math.sin(this.t * 43.7) * .4 <= -.2 && (s *= .05), r) {
                    let e = (Math.floor(t.beat * 2) + Math.round(o.phase)) % 2 == 0;
                    s = Qr.matches ? .6 + n * .4 : e ? .4 + n * 1.6 : .08
                }
                o.beam.setFloat(`intensity`, s * (.5 + this.level * .35) * a), o.beam.setFloat(`time`, this.t), o.beam.setVector3(`cameraPosition`, t.camera), o.beam.setColor3(`color`, i), o.bulb.emissiveColor.copyFrom(i).scaleInPlace(.6 + s)
            }
        }
    },
    Q = (e, t, n) => new T(e, t, n),
    $ = (e, t, n, r) => new o(e, t, n, r);

function ei(e, t, n, r) {
    let i = new de(t, r.capacity, e);
    i.particleTexture = n, i.emitter = r.at;
    let a = new se;
    return [a.minEmitBox, a.maxEmitBox] = r.box, [a.direction1, a.direction2] = r.dir, i.particleEmitterType = a, [i.color1, i.color2, i.colorDead] = r.colors, [i.minSize, i.maxSize] = r.size, [i.minLifeTime, i.maxLifeTime] = r.life, [i.minEmitPower, i.maxEmitPower] = r.power, r.gravity && (i.gravity = r.gravity), r.spin && ([i.minAngularSpeed, i.maxAngularSpeed] = [-r.spin, r.spin]), r.grow && (i.addSizeGradient(0, r.grow[0]), i.addSizeGradient(1, r.grow[1])), i.blendMode = r.add ? de.BLENDMODE_ADD : de.BLENDMODE_STANDARD, r.prewarm && (i.preWarmCycles = r.prewarm, i.preWarmStepOffset = 10), i.emitRate = r.rate ?? 0, i.start(), i
}
var ti = class {
        amount;
        motes;
        steam = [];
        smoke;
        machine;
        pipeGrit;
        clubGrit;
        machineFor = 0;
        lastBeat = 0;
        constructor(e, t, n) {
            this.amount = n;
            let r = Math.max(.5, n),
                i = (W.zMin + W.zMax) / 2;
            this.motes = ei(e, `motes`, t, {
                capacity: Math.round(500 * n),
                at: Q(0, 0, i),
                box: [Q(W.xMin + 1, 1.5, W.zMin - i + 1), Q(W.xMax - 1, W.height - 1, W.zMax - i - 1)],
                dir: [Q(-.05, -.02, -.05), Q(.05, .06, .05)],
                colors: [$(.8, .8, 1, .35), $(1, .7, .9, .25), $(0, 0, 0, 0)],
                size: [.02, .05],
                life: [6, 12],
                power: [.05, .2],
                rate: 45 * n,
                add: !0,
                prewarm: 60
            });
            for (let r = U.zStart + 12; r < U.zEnd - 5; r += 28) this.steam.push(ei(e, `steam`, t, {
                capacity: Math.round(60 * n),
                at: Q(0, .05, r),
                box: [Q(-.4, 0, -.25), Q(.4, 0, .25)],
                dir: [Q(-.1, 1, -.1), Q(.1, 1, .1)],
                colors: [$(.7, .75, .8, .09), $(.6, .65, .75, .06), $(.5, .5, .6, 0)],
                size: [.4, 1.1],
                life: [2.5, 4.5],
                power: [.25, .55],
                rate: 9 * n,
                grow: [.3, 2.2],
                spin: .4
            }));
            this.smoke = ei(e, `floor-smoke`, t, {
                capacity: Math.round(160 * r),
                at: Q(0, 0, 6),
                box: [Q(W.xMin + 1, .2, W.zMin - 5), Q(W.xMax - 1, 1.6, W.zMax - 7)],
                dir: [Q(-.15, .02, -.15), Q(.15, .1, .15)],
                colors: [$(.62, .68, .76, .07), $(.55, .6, .7, .05), $(.5, .55, .62, 0)],
                size: [3, 6.5],
                life: [9, 16],
                power: [.08, .25],
                rate: 12 * n,
                spin: .08,
                prewarm: 120
            }), this.machine = ei(e, `smoke-machine`, t, {
                capacity: Math.round(220 * r),
                at: Q(0, G.top + .3, G.zMax + .4),
                box: [Q(-.2, 0, -.2), Q(.2, .1, .2)],
                dir: [Q(-1, .25, -1.4), Q(1, .6, -.6)],
                colors: [$(.7, .75, .82, .12), $(.6, .66, .74, .09), $(.55, .6, .66, 0)],
                size: [.8, 1.6],
                life: [3, 6],
                power: [1.2, 2.6],
                gravity: Q(0, -.05, 0),
                grow: [.6, 5]
            });
            let a = (n, i, a, o) => ei(e, n, t, {
                capacity: Math.round(i * r),
                at: a,
                box: o,
                dir: [Q(-.05, -.2, -.05), Q(.05, -.05, .05)],
                colors: [$(.62, .6, .57, .55), $(.5, .49, .47, .4), $(.45, .44, .42, 0)],
                size: [.012, .03],
                life: [1.2, 2.2],
                power: [.1, .4],
                gravity: Q(0, -3.2, 0)
            });
            this.pipeGrit = a(`pipe-grit`, 260, Q(0, U.centerY + U.radius - .15, U.zEnd - 12), [Q(-1.2, 0, -10), Q(1.2, 0, 10)]), this.clubGrit = a(`club-grit`, 500, Q(0, W.height - .1, 0), [Q(W.xMin + 1.5, 0, W.zMin + 2), Q(W.xMax - 1.5, 0, W.zMax - 2)])
        }
        drop() {
            this.machineFor = 1.4
        }
        update(e, t) {
            let n = this.amount,
                r = t.player.z;
            this.motes.emitRate = t.zone === `club` ? 45 * n : t.zone === `pipe` && r > U.zEnd - 15 ? 10 * n : 0;
            for (let e of this.steam) e.emitRate = r > U.zStart - 30 && r < U.zEnd + 5 ? 9 * n : 0;
            if (this.smoke.emitRate = t.zone === `club` || t.zone === `pipe` && r > U.zEnd - 20 ? 12 * n : 0, this.machineFor = Math.max(0, this.machineFor - e), this.machine.emitRate = this.machineFor > 0 ? 90 : 0, Math.floor(t.beat) !== Math.floor(this.lastBeat)) {
                let e = D((r - (U.zEnd - 34)) / 16);
                t.live.pipe && e > 0 && t.bass > .35 && (this.pipeGrit.manualEmitCount = Math.round(22 * e * t.bass * n)), t.live.club && t.drop && (this.clubGrit.manualEmitCount = Math.round(70 * n))
            }
            this.lastBeat = t.beat
        }
    },
    ni = 10,
    ri = 22,
    ii = 1.35,
    ai = class extends Cr {
        lamps = [];
        spills;
        ripples;
        t = 0;
        constructor(e, t) {
            super();
            let n = Math.round((U.zEnd - U.zStart) / ni),
                r = Z(e, `pipe-wall-mat`, {
                    texture: t.concrete,
                    bump: t.concreteBump,
                    color: X(.5, .52, .52),
                    specular: X(.14, .15, .16),
                    gloss: 24,
                    sides: `lit`,
                    lights: 5
                }),
                i = Z(e, `pipe-floor-mat`, {
                    texture: t.concrete,
                    color: X(.42, .43, .44),
                    specular: X(.35, .36, .4),
                    gloss: 64,
                    lights: 5
                }),
                a = Z(e, `pipe-water-mat`, {
                    color: X(.02, .03, .035),
                    specular: X(.9, .95, 1),
                    gloss: 180,
                    bump: t.ripple,
                    alpha: .82,
                    lights: 5
                }),
                o = Z(e, `pipe-rib-mat`, {
                    texture: t.concrete,
                    color: X(.38, .39, .4),
                    specular: X(.06, .06, .07),
                    lights: 5
                });
            this.ripples = t.ripple;
            let s = [];
            for (let t = 0; t < n; t++) {
                let n = U.zStart + t * ni,
                    c = n + ni / 2,
                    l = x(`pipe-shell-${t}`, {
                        height: ni,
                        diameter: U.radius * 2,
                        tessellation: 48,
                        cap: w.NO_CAP,
                        sideOrientation: w.BACKSIDE
                    }, e);
                l.rotation.x = Math.PI / 2, l.position.set(0, U.centerY, c), l.material = r, Xn(l, 6, 3);
                let u = C(`pipe-floor-${t}`, {
                    width: U.halfFloor * 2 + .2,
                    height: .4,
                    depth: ni
                }, e);
                u.position.set(0, -.2, c), u.material = i, Xn(u, 1, 2.5);
                let d = v(`pipe-water-${t}`, {
                    width: 1.1,
                    height: ni
                }, e);
                d.rotation.x = Math.PI / 2, d.position.set(0, .012, c), d.material = a, Xn(d, 2, 18);
                let f = [l, u, d, ...[n, n + 5].map(n => {
                    let r = ce(`pipe-rib-${t}-${n}`, {
                        diameter: U.radius * 2 - .08,
                        thickness: .2,
                        tessellation: 48
                    }, e);
                    return r.rotation.x = Math.PI / 2, r.position.set(0, U.centerY, n), r.material = o, r
                })];
                for (let e of f) e.freezeWorldMatrix();
                s.push(f), this.meshes.push(...f)
            }
            let l = Z(e, `cage-mat`, {
                    color: X(.05, .05, .05),
                    specular: .3
                }),
                u = Z(e, `pipe-bulb-mat`, {
                    unlit: !0,
                    emissive: an
                });
            for (let t = 0; t < n; t++) {
                let n = U.zStart + t * ni + ni / 2,
                    r = t % 2 == 0 ? -1 : 1,
                    i = Math.PI / 2 + r * .55,
                    a = U.radius - .25,
                    o = new T(Math.cos(i) * a, U.centerY + Math.sin(i) * a, n),
                    s = oe(`bulb-${t}`, {
                        diameter: .2,
                        segments: 8
                    }, e);
                s.position.copyFrom(o), s.material = u;
                let c = x(`cage-${t}`, {
                    height: .3,
                    diameter: .3,
                    tessellation: 8
                }, e);
                c.position.copyFrom(o), c.rotation.z = r * .55, c.material = l, c.visibility = .5, this.meshes.push(s, c);
                let d = $n(e, `pipe-lamp-${t}`, o.add(new T(-r * .2, -.3, 0)), an, {
                    intensity: ii,
                    range: 15,
                    shine: .8
                });
                this.lamps.push({
                    light: d,
                    bulb: s,
                    flicker: t === 2 ? 1 : t === 4 ? .5 : 0,
                    z: n
                })
            }
            this.spills = [$n(e, `pipe-spill`, new T(0, 2.2, U.zEnd - 3), on, {
                intensity: 0,
                range: 22,
                shine: 1
            }), $n(e, `pipe-spill-2`, new T(0, 3.5, U.zEnd - 8), on, {
                intensity: 0,
                range: 18,
                shine: 1
            })], this.lights.push(...this.lamps.map(e => e.light), ...this.spills);
            let d = Z(e, `grate-mat`, {
                color: X(.06, .06, .06),
                specular: .4
            });
            for (let t = U.zStart + 12; t < U.zEnd - 5; t += 14)
                for (let n = -2; n <= 2; n++) {
                    let r = C(`grate-bar`, {
                        width: .9,
                        height: .03,
                        depth: .05
                    }, e);
                    r.position.set(0, .02, t + n * .12), r.material = d, this.meshes.push(r)
                }
            let f = Z(e, `cone-mat`, {
                color: X(1, .35, .05),
                specular: X(.3, .2, .1),
                emissive: X(.08, .02, 0)
            });
            for (let [t, n, r] of [
                    [1.55, U.zStart + 19, 0],
                    [-1.6, U.zStart + 41, 1.3],
                    [1.4, U.zStart + 42.5, 0]
                ]) {
                let i = x(`traffic-cone`, {
                    height: .7,
                    diameterTop: .06,
                    diameterBottom: .36,
                    tessellation: 12
                }, e);
                i.bakeTransformIntoVertices(c.Translation(0, .35, 0)), i.position.set(t, r ? .18 : 0, n), i.rotation.z = r, i.material = f, this.meshes.push(i)
            }
            let p = this.meshes.filter(e => !s.some(t => t.includes(e)));
            this.lamps.forEach((e, t) => {
                e.light.includedOnlyMeshes = [...s[t - 1] ?? [], ...s[t], ...s[t + 1] ?? [], ...p.filter(t => Math.abs(t.position.z - e.z) < 16)]
            });
            let m = s.length - 1;
            this.spills[0].includedOnlyMeshes = [...s[m], ...s[m - 1]], this.spills[1].includedOnlyMeshes = [...s[m], ...s[m - 1], ...s[m - 2]]
        }
        update(e, t, n, r) {
            this.t += e;
            let i = k(U.zEnd - 30, U.zEnd - 2, t.z);
            for (let e of this.spills) wr(e, r && i > 0);
            for (let e of this.lamps) wr(e.light, r && Math.abs(e.z - t.z) < ri);
            if (!r) return;
            for (let e of this.lamps) {
                let n = 1;
                e.flicker > 0 && (n = Math.sin(this.t * 23.1 + e.z) * Math.sin(this.t * 7.7) + Math.sin(this.t * 51.3) * .3 > -.35 * e.flicker ? 1 : .08, e.bulb.visibility = n > .5 ? 1 : .25), e.light.intensity = ii * n * Math.max(0, Math.min(1, (ri - Math.abs(e.z - t.z)) / 7))
            }
            let a = (.3 + n * .9) * i;
            this.spills[0].intensity = a * 1.3, this.spills[1].intensity = a * .9, this.ripples.vOffset -= e * .25
        }
    },
    oi = 3.6,
    si = 6.4,
    ci = 14,
    li = 5.4,
    ui = .12,
    di = .14,
    fi = class {
        avatar;
        events;
        characterName = null;
        pos = new T;
        vx = 0;
        vz = 0;
        vy = 0;
        facing = 0;
        grounded = !0;
        coyote = 0;
        buffer = 0;
        gait = {
            phase: 0,
            speed: 0,
            air: 0,
            rise: 0,
            land: 0,
            lean: 0,
            time: 0
        };
        base = Be();
        groove = Be();
        grooveFrom = Be();
        overlay = Be();
        grooveWeight = 0;
        grooveNow = at;
        groovePrev = null;
        grooveFade = 1;
        stillTime = 0;
        move = null;
        lastStep = 0;
        turnRate = 0;
        eyeLocal = [0, 0, 0];
        constructor(e, t, n = null) {
            this.avatar = e, this.events = t, this.characterName = n
        }
        setAvatar(e, t = null) {
            let n = this.avatar;
            this.avatar = e, t && (this.characterName = t), n && n !== e && n.dispose()
        }
        teleport(e, t, n) {
            this.pos.set(e, 0, t), this.vx = this.vz = this.vy = 0, this.facing = n, this.grounded = !0
        }
        get speed() {
            return Math.hypot(this.vx, this.vz)
        }
        get surface() {
            let e = Rt(this.pos.z);
            return e === `forest` ? `dirt` : e === `pipe` && Math.abs(this.pos.x) < .6 ? `wet` : `concrete`
        }
        eye(e) {
            let [t, n, r] = Qe(this.avatar.pose, this.eyeLocal), i = Math.sin(this.facing), a = Math.cos(this.facing);
            return e.set(this.pos.x + t * a + r * i, this.pos.y + n, this.pos.z - t * i + r * a)
        }
        dance(e, t) {
            this.move = {
                kind: e,
                beat: Math.round(t * 2) / 2
            }
        }
        update(e, t, n, r, i, a, o) {
            this.moveBody(e, t, n, r, i), this.animate(e, a, o)
        }
        moveBody(e, t, n, r, i) {
            let a = 0,
                o = 0,
                s = Math.hypot(t.x, t.z);
            if (s > .01) {
                let e = t.x / Math.max(1, s),
                    r = t.z / Math.max(1, s),
                    c = Math.sin(n),
                    l = Math.cos(n),
                    u = (t.sprint ? si : oi) * (1 - i * .4) * Math.min(1, s);
                a = (l * e + c * r) * u, o = (-c * e + l * r) * u
            }
            let c = this.grounded ? a || o ? 16 : 20 : 5,
                l = a - this.vx,
                u = o - this.vz,
                d = Math.hypot(l, u);
            if (d > 0) {
                let t = Math.min(d, c * e);
                this.vx += l / d * t, this.vz += u / d * t
            }
            this.buffer = t.jump ? di : Math.max(0, this.buffer - e), this.coyote = this.grounded ? ui : Math.max(0, this.coyote - e), this.buffer > 0 && this.coyote > 0 && (this.vy = li, this.grounded = !1, this.coyote = this.buffer = 0, this.events.jump());
            let f = this.pos.x + this.vx * e,
                p = this.pos.z + this.vz * e,
                [m, h] = Jt(this.pos.x, this.pos.z, f, p, this.pos.y, r);
            if (e > 0) {
                let t = (e, t) => Math.sign(t) === Math.sign(e) ? Math.sign(e) * Math.min(Math.abs(e), Math.abs(t)) : 0;
                Math.abs(m - f) > 1e-4 && (this.vx = t(this.vx, (m - this.pos.x) / e)), Math.abs(h - p) > 1e-4 && (this.vz = t(this.vz, (h - this.pos.z) / e))
            }
            this.pos.x = m, this.pos.z = h;
            let g = this.grounded;
            this.vy -= ci * e, this.pos.y += this.vy * e;
            let _ = qt(this.pos.x, this.pos.z, this.pos.y);
            if (g && this.vy <= 0 && this.pos.y > _ && this.pos.y - _ < .3 && (this.pos.y = _), this.pos.y <= _) {
                if (!this.grounded) {
                    let e = E((-this.vy - 2) / 6, 0, 1.5);
                    this.events.land(this.surface, e), this.gait.land = Math.min(1, .4 + e)
                }
                this.pos.y = _, this.vy = 0, this.grounded = !0
            } else this.pos.y > _ + .05 && (this.grounded = !1);
            let v = this.facing;
            t.faceCamera ? this.facing = n : this.speed > .3 && (this.facing += be(Math.atan2(this.vx, this.vz) - this.facing) * Math.min(1, e * (this.grounded ? 10 : 4)));
            let y = t.faceCamera ? 0 : be(this.facing - v) / Math.max(e, .001);
            this.turnRate = A(this.turnRate, y, 6, e)
        }
        animate(e, t, n) {
            let r = this.gait,
                i = this.speed;
            if (r.time += e, r.speed = A(r.speed, i < .05 ? 0 : i <= oi ? i / oi : 1 + (i - oi) / 2.8000000000000003, 10, e), r.phase += i / (1.25 + Math.max(0, r.speed - 1) * .6) * Math.PI * e, r.air = A(r.air, +!this.grounded, 12, e), r.rise = E(this.vy / li, -1, 1), r.land = Math.max(0, r.land - e * 5), r.lean = E(-this.turnRate * .05 * Math.min(1, i / oi), -.35, .35), this.grounded && i > .5) {
                let e = Math.floor(r.phase / Math.PI);
                e !== this.lastStep && (this.lastStep = e, this.events.step(this.surface, Math.min(1, i / si)))
            }
            pt(r, this.base), this.stillTime = i < .3 && this.grounded ? this.stillTime + e : 0, n && !st(n, this.grooveNow) && (this.grooveWeight > .001 && (this.groovePrev = this.grooveNow, this.grooveFade = 0), this.grooveNow = n), this.grooveWeight = A(this.grooveWeight, n && this.stillTime > .35 ? 1 : 0, 4, e), this.grooveWeight > .001 && (ct(this.grooveNow.loop, ot(this.grooveNow, t), this.groove), this.groovePrev && this.grooveFade < 1 && (this.grooveFade = Math.min(1, this.grooveFade + e * 4), ct(this.groovePrev.loop, ot(this.groovePrev, t), this.grooveFrom), He(this.grooveFrom, this.groove, O(this.grooveFade), this.groove)), He(this.base, this.groove, this.grooveWeight, this.base));
            let a = Ve(this.base, this.avatar.pose);
            if (this.move) {
                let e = t - this.move.beat,
                    n = ut(e);
                n <= 0 && e > .2 ? this.move = null : (dt(this.move.kind, e, this.overlay), He(a, this.overlay, n, a), a.y = this.base.y * (1 - n) + this.overlay.y * n)
            }
            this.avatar.mesh.position.copyFrom(this.pos), this.avatar.mesh.rotation.y = this.facing, this.avatar.commit()
        }
    };
s.ShadersStore.aftersSkyVertexShader = `
precision highp float;
attribute vec3 position;
uniform mat4 worldViewProjection;
varying vec3 vDir;
void main() {
  vDir = normalize(position);
  vec4 p = worldViewProjection * vec4(position, 1.0);
  gl_Position = p.xyww;
}`, s.ShadersStore.aftersSkyFragmentShader = `
precision highp float;
varying vec3 vDir;
uniform vec3 moonDir;
uniform vec3 horizon;
uniform vec3 zenith;
uniform vec3 fogColor;
uniform float haze;
uniform float time;
${tr}
void main() {
  vec3 d = normalize(vDir);
  float h = clamp(d.y, -0.2, 1.0);
  vec3 col = mix(horizon, zenith, pow(max(h, 0.0), 0.55));
  // Stars: hashed cells, twinkling, fading into the haze near the horizon.
  vec3 sp = d * 180.0;
  vec3 cellId = floor(sp);
  float s = hash3(cellId);
  vec3 center = cellId + 0.5 + (vec3(hash3(cellId + 3.1), hash3(cellId + 7.7), hash3(cellId + 1.3)) - 0.5) * 0.7;
  float dist = length(sp - center);
  float star = step(0.985, s) * smoothstep(0.35, 0.0, dist) * (0.55 + 0.45 * sin(time * (1.0 + s * 4.0) + s * 40.0));
  col += vec3(0.85, 0.9, 1.0) * star * smoothstep(0.02, 0.35, h) * 1.6;
  // Moon + halo
  float md = max(dot(d, normalize(moonDir)), 0.0);
  float disc = smoothstep(0.99955, 0.9997, md);
  float craters = noise3(d * 900.0) * 0.18;
  col += vec3(0.95, 0.93, 0.85) * disc * (1.05 - craters);
  col += vec3(0.35, 0.42, 0.6) * pow(md, 350.0) * 0.9 + vec3(0.12, 0.15, 0.24) * pow(md, 24.0) * 0.6;
  // Cloud wisps drifting across the moonlight
  float c = noise3(vec3(d.xz / max(d.y, 0.08) * 2.2 + vec2(time * 0.01, 0.0), time * 0.004).xzy);
  c = smoothstep(0.55, 0.85, c) * smoothstep(0.02, 0.3, h);
  col = mix(col, horizon * 1.5 + vec3(0.08, 0.09, 0.12) * pow(md, 6.0), c * 0.6);
  // Low cloud and haze swallow the horizon into the fog.
  float veil = haze * (1.0 - smoothstep(-0.05, 0.55, h)) + haze * 0.25;
  col = mix(col, fogColor, clamp(veil, 0.0, 1.0));
  gl_FragColor = vec4(col, 1.0);
}`;
var pi = class {
    mesh;
    mat;
    t = 0;
    constructor(e, t) {
        let n = new fe(`sky-mat`, e, {
            vertex: `aftersSky`,
            fragment: `aftersSky`
        }, {
            attributes: [`position`],
            uniforms: [`worldViewProjection`, `moonDir`, `horizon`, `zenith`, `fogColor`, `haze`, `time`]
        });
        n.setVector3(`moonDir`, t), n.setColor3(`horizon`, X(.05, .065, .1)), n.setColor3(`zenith`, X(.006, .01, .028)), n.setFloat(`time`, 0), n.disableDepthWrite = !0, n.backFaceCulling = !1, this.mat = n, this.setHaze(X(.15, .18, .22), .6), this.mesh = oe(`sky`, {
            diameter: 700,
            segments: 16,
            sideOrientation: w.BACKSIDE
        }, e), this.mesh.material = n, this.mesh.infiniteDistance = !0, this.mesh.applyFog = !1
    }
    update(e) {
        this.t += e, this.mat.setFloat(`time`, this.t)
    }
    setHaze(e, t) {
        this.mat.setColor3(`fogColor`, e), this.mat.setFloat(`haze`, t)
    }
    setVisible(e) {
        this.mesh.setEnabled(e)
    }
};

function mi(e, t) {
    let n = qn(t),
        r = Float32Array.from({
            length: e * e
        }, n);
    return (t, n, i = e, a = i) => {
        let o = Math.max(1, Math.min(e, Math.round(i))),
            s = Math.max(1, Math.min(e, Math.round(a))),
            c = Math.floor(t),
            l = Math.floor(n),
            u = t - c,
            d = n - l,
            f = ye(c, o),
            p = ye(l, s),
            m = (f + 1) % o,
            h = (p + 1) % s,
            g = O(u),
            _ = O(d),
            v = r[p * e + f],
            y = r[p * e + m],
            b = r[h * e + f],
            ee = r[h * e + m];
        return v + (y - v) * g + (b - v) * _ + (v - y - b + ee) * g * _
    }
}

function hi(e, t, n, r, i) {
    let a = 0,
        o = .5,
        s = 1;
    for (let c = 0; c < r; c++) {
        let r = i * s;
        a += e(t * r, n * r, r <= 64 ? r : 64) * o, s *= 2, o *= .5
    }
    return a
}

function gi(e, t, n, r, i = !0) {
    let a = new pe(t, {
            width: n,
            height: n
        }, e, !0),
        o = a.getContext(),
        s = o.createImageData(n, n);
    for (let e = 0; e < n; e++)
        for (let t = 0; t < n; t++) {
            let [i, a, o, c] = r(t / n, e / n), l = (e * n + t) * 4;
            s.data[l] = i, s.data[l + 1] = a, s.data[l + 2] = o, s.data[l + 3] = c ?? 255
        }
    return o.putImageData(s, 0, 0), a.update(), i && (a.wrapU = a.wrapV = S.WRAP_ADDRESSMODE), a
}

function _i(e, t) {
    let n = mi(64, 7),
        r = mi(64, 91),
        i = mi(64, 4242),
        a = gi(e, `tex-concrete`, t, (e, t) => {
            let a = hi(n, e, t, 5, 8),
                o = hi(r, e, t, 3, 3),
                s = i(e * 64 * 4, t * 64 * 4) > .93 ? .55 : 1,
                c = Math.max(0, i(e * 24, t * 3, 24, 3) * .7 + i(e * 48, t * 6, 48, 6) * .3 - .55) * 1.2,
                l = (.55 + a * .35 - o * .18 - c * .3) * s,
                u = Math.max(0, Math.min(255, l * 255));
            return [u, u * .99, u * .97]
        }),
        o = gi(e, `tex-concrete-bump`, t, (e, r) => {
            let a = hi(n, e, r, 5, 8),
                o = i(e * 256, r * 256) > .93 ? .2 : 0,
                s = 1 / t,
                c = hi(n, e + s, r, 5, 8) - a,
                l = hi(n, e, r + s, 5, 8) - a,
                u = -c * 60 - o * .2,
                d = -l * 60,
                f = Math.hypot(u, d, 1);
            return [(u / f * .5 + .5) * 255, (d / f * .5 + .5) * 255, (1 / f * .5 + .5) * 255]
        }),
        s = gi(e, `tex-forest-floor`, t, (e, t) => {
            let a = hi(r, e, t, 5, 6),
                o = Math.max(0, hi(n, e, t, 3, 3) - .5) * 2.2,
                s = i(e * 192, t * 192),
                c = s > .83 ? (s - .83) * 4 : 0,
                l = Math.max(0, n(e * 256, t * 64, 64, 64) - .72) * 3 + Math.max(0, r(e * 64, t * 256, 64, 64) - .72) * 3;
            return [44 + a * 42 + c * 70 + l * 38 - o * 18, 36 + a * 34 + o * 34 + c * 42 + l * 22, 26 + a * 22 + l * 10]
        }),
        c = gi(e, `tex-bark`, 64, (e, t) => {
            let a = r(e * 16, t * 2, 16, 2),
                o = Math.abs(Math.sin((e * 12 + n(e * 8, t * 4, 8, 4) * 1.6) * Math.PI)) ** .35,
                s = i(e * 64, t * 16, 64, 16),
                c = 18 + o * (38 + a * 30) + s * 14;
            return [c * 1.12, c * .92, c * .74]
        }),
        l = (t, n, r, i) => {
            let a = new pe(t, {
                    width: n,
                    height: r
                }, e, !0),
                o = a.getContext();
            return o.clearRect(0, 0, n, r), i(o, qn(t.length * 7919 + n)), a.update(), a.hasAlpha = !0, a
        },
        u = l(`tex-grass`, 256, 256, (e, t) => {
            for (let n = 0; n < 70; n++) {
                let n = 128 + (t() - .5) * 170,
                    r = 70 + t() * 170,
                    i = (t() - .5) * 110,
                    a = 2.5 + t() * 4.5,
                    o = 55 + t() * 75,
                    s = t() < .35,
                    c = e.createLinearGradient(0, 256, 0, 256 - r);
                c.addColorStop(0, `rgb(${o*.3},${o*.45},${o*.26})`), c.addColorStop(.7, `rgb(${o*.62},${o*.86},${o*.5})`), c.addColorStop(1, s ? `rgb(${o*1.1},${o},${o*.66})` : `rgb(${o*.72},${o},${o*.58})`), e.fillStyle = c, e.beginPath(), e.moveTo(n - a, 256), e.quadraticCurveTo(n + i * .3, 256 - r * .55, n + i, 256 - r), e.quadraticCurveTo(n + i * .3 + a * .3, 256 - r * .55, n + a, 256), e.closePath(), e.fill()
            }
        }),
        d = l(`tex-fir-branch`, 256, 128, (e, t) => {
            let n = (n, r, i, a, o) => {
                    for (let s = 0; s < a; s += 1.6) {
                        let c = n + Math.cos(i) * s,
                            l = r + Math.sin(i) * s;
                        for (let n of [-1, 1]) {
                            let r = i + n * (.9 + t() * .5),
                                u = 5 + t() * 5 * (1 - s / a) + 3,
                                d = o + t() * 30;
                            e.strokeStyle = `rgb(${d*.34},${d*.58+6},${d*.4})`, e.lineWidth = 1.2 + t() * .6, e.beginPath(), e.moveTo(c, l), e.lineTo(c + Math.cos(r) * u, l + Math.sin(r) * u), e.stroke()
                        }
                    }
                },
                r = e => 64 + (e / 244) ** 1.8 * 18;
            for (let e = 14; e < 234; e += 9 + t() * 5) {
                let i = (1 - e / 244) * 58 + 10;
                for (let a of [-1, 1]) {
                    let o = a * (.75 + t() * .35) + .1;
                    n(e, r(e), o, i * (.55 + t() * .45), 70 + e / 244 * 50)
                }
            }
            n(4, r(4), .06, 244, 90), e.strokeStyle = `rgb(52,38,26)`, e.lineWidth = 2.4, e.beginPath(), e.moveTo(0, r(0));
            for (let t = 0; t <= 244; t += 8) e.lineTo(t, r(t));
            e.stroke()
        }),
        f = l(`tex-fern`, 128, 256, (e, t) => {
            for (let n = 230; n > 18; n -= 7) {
                let r = (250 - n) / 232,
                    i = Math.sin(Math.min(1, r * 1.15) * Math.PI) * 52 + 6,
                    a = 64 + Math.sin(r * 2.2) * 8;
                for (let o of [-1, 1]) {
                    let s = 70 + t() * 50;
                    e.fillStyle = `rgb(${s*.42},${s*.78},${s*.4})`, e.beginPath(), e.moveTo(a, n), e.quadraticCurveTo(a + o * i * .55, n - 9, a + o * i, n - 4 - r * 6), e.quadraticCurveTo(a + o * i * .5, n + 3, a, n + 4), e.fill()
                }
            }
            e.strokeStyle = `rgb(58,74,38)`, e.lineWidth = 2.5, e.beginPath(), e.moveTo(64, 250);
            for (let t = 250; t > 18; t -= 10) e.lineTo(64 + Math.sin((250 - t) / 232 * 2.2) * 8, t);
            e.stroke()
        }),
        p = l(`tex-chain-link`, 128, 128, e => {
            e.lineWidth = 3.2;
            for (let t = -2; t <= 4; t++)
                for (let n of [1, -1]) {
                    e.strokeStyle = n > 0 ? `rgb(150,154,158)` : `rgb(128,122,114)`, e.beginPath();
                    let r = t * 32;
                    e.moveTo(r, n > 0 ? 0 : 128), e.lineTo(r + 128, n > 0 ? 128 : 0), e.stroke()
                }
        });
    p.wrapU = p.wrapV = S.WRAP_ADDRESSMODE;
    let m = gi(e, `tex-dot`, 64, (e, t) => {
        let n = Math.hypot(e - .5, t - .5) * 2;
        return [255, 255, 255, Math.max(0, 1 - n) ** 2.2 * 255]
    }, !1);
    m.hasAlpha = !0;
    let h = mi(32, 555);
    return {
        concrete: a,
        concreteBump: o,
        floor: s,
        bark: c,
        grass: u,
        dot: m,
        ripple: gi(e, `tex-ripple`, 128, (e, t) => {
            let n = 1 / 128,
                r = h(e * 16, t * 16, 16),
                i = h((e + n) * 16, t * 16, 16) - r,
                a = h(e * 16, (t + n) * 16, 16) - r,
                o = -i * 12,
                s = -a * 12,
                c = Math.hypot(o, s, 1);
            return [(o / c * .5 + .5) * 255, (s / c * .5 + .5) * 255, (.5 / c + .5) * 255]
        }),
        branch: d,
        fern: f,
        chainLink: p
    }
}
var vi = () => new Promise(e => requestAnimationFrame(() => e())),
    yi = class e {
        stage;
        forest;
        pipe;
        club;
        lights;
        crowd;
        player;
        dj;
        camera;
        sky;
        particles;
        atmosphere;
        blob;
        caps;
        shown = {
            forest: !0,
            pipe: !0,
            club: !0
        };
        constructor(e, t, n, r, i, a, o, s, c, l, u, d, f, p) {
            this.stage = e, this.forest = t, this.pipe = n, this.club = r, this.lights = i, this.crowd = a, this.player = o, this.dj = s, this.camera = c, this.sky = l, this.particles = u, this.atmosphere = d, this.blob = f, this.caps = p
        }
        static async build(t, n, r, i) {
            let a = async e => {
                i(e), await vi()
            };
            await a(.02);
            let o = new Kn(t, n),
                {
                    scene: s,
                    spec: c
                } = o;
            await a(.08);
            let l = _i(s, c.texture);
            await a(.2);
            let u = new pi(s, new T(.28, .52, .8).normalize()),
                d = new Yr(s, l, c);
            await a(.32);
            let f = new ai(s, l);
            await a(.42);
            let p = new Dr(s, l),
                m = new $r(s),
                preferred = getSavedCharacter(),
                [g, _, ...v] = await br(s, c.people + 2, e => i(.48 + .06 * e), preferred);
            await a(.55);
            let y = new jr(s, c.crowd, hr(s), v);
            await a(.6);
            let b = xr(`player`, s, g);
            b.material = Sr(`player-mat`, s, g, .2, 8);
            let ee = new fi(new gr(b), r, g.name),
                te = xr(`dj`, s, _);
            te.material = Sr(`dj-mat`, s, _, .18);
            let x = new gr(te);
            await a(.66);
            let ne = new ti(s, l.dot, c.particles),
                re = new rr(s, d.moonDir, c.particles),
                ie = new ur(o.camera);
            for (let e of [...p.meshes, ...m.meshes, ...y.meshes, x.mesh]) e.material instanceof h && gn(e.material);
            for (let e of [d, f, p]) e.illuminate(b);
            for (let e of y.meshes) p.illuminate(e, p.roomLights);
            p.illuminate(x.mesh);
            let S = new e(o, d, f, p, m, y, ee, x, ie, u, ne, re, bi(o), xi(o));
            return S._illuminators = [d, f, p], Vn(s, new Set([`tex-dot`, `tex-blob`])), await S.warmUp(i), S
        }
        showZones(e) {
            let t = this.shown;
            this.caps.woods.setEnabled(!e.pipe), this.caps.club.setEnabled(!e.club || !e.pipe), e.forest !== t.forest && this.forest.setVisible(t.forest = e.forest), e.pipe !== t.pipe && this.pipe.setVisible(t.pipe = e.pipe), e.club !== t.club && (t.club = e.club, this.club.setVisible(e.club), this.crowd.setVisible(e.club), this.dj.mesh.setEnabled(e.club))
        }
        async swapPlayer(name) {
            if (!name || name === this.player.characterName) return this.player;
            let scene = this.stage.scene,
                roster = await loadRoster(),
                meta = roster.find(e => e.name === name);
            if (!meta) throw new Error(`Unknown character ${name}`);
            let asset = await loadCharacterAsset(scene, meta),
                oldMesh = this.player.avatar.mesh,
                mesh = xr(`player`, scene, asset);
            mesh.material = Sr(`player-mat`, scene, asset, .2, 8);
            // Drop old mesh from light inclusion lists
            for (let sys of this._illuminators || []) {
                for (let light of sys.lights || []) {
                    let i = light.includedOnlyMeshes?.indexOf?.(oldMesh);
                    i >= 0 && light.includedOnlyMeshes.splice(i, 1)
                }
            }
            let avatar = new gr(mesh);
            this.player.setAvatar(avatar, name);
            mesh.position.copyFrom(this.player.pos);
            mesh.rotation.y = this.player.facing;
            for (let sys of this._illuminators || []) sys.illuminate?.(mesh);
            this.player.avatar.commit();
            return this.player
        }
        async warmUp(e) {
            let {
                scene: t,
                camera: n
            } = this.stage;
            await t.whenReadyAsync();
            let r = [
                [At.x, At.z]
            ];
            for (let e = U.zStart - 30; e <= U.zEnd + 6; e += 3) r.push([0, e]);
            r.push([jt.x, jt.z], [0, 0], [0, 12]);
            let i = this.player;
            for (let a = 0; a < r.length; a++) {
                let [o, s] = r[a];
                i.teleport(o, s, 0), i.avatar.mesh.position.copyFrom(i.pos);
                let c = zt(s);
                this.showZones(c), this.club.setLightsOn(c.club), this.forest.update(i.pos, .5, c.forest), this.pipe.update(.016, i.pos, .5, c.pipe), this.sky.setVisible(c.forest);
                for (let e of [1, -1]) n.position.set(o + 1.2, 2.2, s - 4.5 * e), n.setTarget(new T(o, 1.4, s + 2 * e)), await t.whenReadyAsync(), t.render();
                e(.72 + .26 * (a + 1) / r.length), a % 4 == 3 && await vi()
            }
        }
    };

function bi({
    scene: e
}) {
    let t = new pe(`tex-blob`, {
            width: 32,
            height: 32
        }, e, !1),
        n = t.getContext(),
        r = n.createRadialGradient(16, 16, 2, 16, 16, 16);
    r.addColorStop(0, `rgba(0,0,0,0.55)`), r.addColorStop(1, `rgba(0,0,0,0)`), n.fillStyle = r, n.fillRect(0, 0, 32, 32), t.update(), t.hasAlpha = !0;
    let i = y(`player-blob`, {
        width: .9,
        height: .9
    }, e);
    return i.material = Z(e, `blob-mat`, {
        texture: t,
        blendTexture: !0,
        unlit: !0,
        emissive: Zt,
        zOffset: -2
    }), i
}

function xi({
    scene: e
}) {
    let t = Z(e, `drain-cap-mat`, {
            color: Zt,
            specular: Zt,
            sides: `both`
        }),
        n = (n, r) => {
            let i = he(n, {
                radius: U.radius + .2,
                tessellation: 32,
                sideOrientation: w.DOUBLESIDE
            }, e);
            return i.position.set(0, U.centerY, r), i.material = t, i.setEnabled(!1), i
        };
    return {
        woods: n(`drain-cap-woods`, U.zStart + .4),
        club: n(`drain-cap-club`, U.zEnd - .3)
    }
}
var Si = 900;
async function Ci() {
    let e = document.querySelector(`#scene`),
        t = new Oe,
        n = new Fe(t),
        r = new Nn(e),
        i = new Rn(document.querySelector(`#ui`), n),
        a = {
            world: 0,
            audio: 0
        },
        o = () => B.progress(Math.min(.99, a.world * .72 + a.audio * .28));
    B.progress(.01);
    let s = t.preload(e => (a.audio = e, o())).catch(e => console.warn(`[afters] audio failed to load`, e)),
        c, l = () => {
            let e = Rt(c?.player.pos.z ?? 0);
            return e === `pipe` ? `pipe` : e === `club` ? `hall` : null
        };
    try {
        c = await yi.build(e, Gn(), {
            step: (e, t) => n.footstep(e, t, l()),
            jump: () => n.jump(l()),
            land: (e, t) => {
                n.land(e, t, l()), c.camera.addTrauma(Math.min(.35, t * .3)), t > .4 && r.rumble(Math.min(.6, t * .4), .2, 120)
            }
        }, e => (a.world = e, o()))
    } catch (e) {
        console.error(e), document.body.append(V(`div`, {
            class: `boot-error`
        }, `This device couldn't start WebGL. Try another browser.`)), B.ready();
        return
    }
    await s, t.setMusicPosition(Nt);
    let u = new Dn(c, t, n, r, i);
    if (Wn()) {
        r.touchUI = !0, r.device = `touch`;
        let e = new In(r);
        i.root.prepend(e.el), u.touch = e
    }
    location.search.includes(`debug`) && Object.assign(window, {
        __afters: {
            game: u,
            world: c,
            audio: t,
            sfx: n
        }
    });
    let {
        engine: d,
        scene: f
    } = c.stage, p = performance.now();
    d.runRenderLoop(() => {
        let e = performance.now(),
            t = Math.min(.05, (e - p) / 1e3);
        p = e;
        try {
            u.update(t)
        } catch (e) {
            console.error(`[afters] frame error`, e)
        }
        // Preview blits from the engine canvas, so render it before the main scene restores the view.
        try {
            u.charPreview?.renderFrame?.()
        } catch (e) {
            console.warn(`[afters] preview frame`, e)
        }
        f.render(), u.afterRender()
    });
    let m = 0,
        h = () => {
            cancelAnimationFrame(m), m = requestAnimationFrame(() => {
                c.stage.resize(), u.touch?.size?.()
            })
        };
    window.addEventListener(`resize`, h), window.addEventListener(`orientationchange`, h);
    let g = window.visualViewport;
    g && (g.addEventListener(`resize`, h), g.addEventListener(`scroll`, h)), u.start(), await new Promise(e => {
        let t = 0,
            n = f.onAfterRenderObservable.add(() => {
                ++t < 3 || (f.onAfterRenderObservable.remove(n), e())
            })
    }), document.body.dataset.ready = `1`, B.progress(1), B.online && await new Promise(e => setTimeout(e, Si)), B.ready()
}

export { Ci as boot };
